export default {
    zh: {
        // SEO Meta
        pageTitle: 'Dreamina 4.0 - 领先的 AI 图像生成模型',
        pageDescription:
            'Dreamina 4.0 是新一代 AI 图像生成模型，提供电影级质量、灵活编辑功能和专业级输出。支持文生图和图生图，立即在 微鲤AI 免费体验。',
        pageKeywords:
            'Dreamina 4.0, AI图像生成, 文生图, 图生图, AI绘画, 图像编辑, 电影级渲染, 微鲤AI',
        ogTitle: 'Dreamina 4.0 AI 图像生成器 | 微鲤AI',
        ogDescription:
            'Dreamina 4.0 提供电影级质量的 AI 图像生成，支持多样化风格和专业级编辑功能',
        twitterTitle: 'Dreamina 4.0 - 专业级 AI 图像生成',
        twitterDescription:
            '体验 Dreamina 4.0 的强大图像生成能力，电影级质量，灵活编辑',

        // Generator Section
        generatorTitle: 'Dreamina 4.0 AI 图像生成器',
        generatorSubtitle:
            '即梦4.0 （Dreamina 4.0）是字节跳动的一款基于先进多模态技术的AI图像生成与编辑模型，专注于为商业设计、艺术创作与社交娱乐场景提供高精度、高自由度的视觉内容生成能力。支持从草图生成、风格迁移到细节优化、多图融合等复杂指令，真正实现“语言驱动创作”，助力个人创作者与企业高效产出专业级视觉内容。',

        // Core Features
        coreFeaturesTitle: 'Dreamina 4.0 核心功能',
        coreFeaturesSubtitle:
            '探索 Dreamina 4.0 的强大功能，开启专业级 AI 图像创作之旅',

        feature1Title: '多维度画面控制与视角重构',
        feature1Desc:
            '支持对画面视角（如平视转俯视）、景别（近景转中景）、比例（自定义画幅）进行灵活调整，精准响应如“将平视视角改为俯视视角，将近景改为中景”等复杂指令，增强画面表现力与适配性。',
        feature1Alt: 'Dreamina 4.0 多维度画面控制示例',

        feature2Title: '风格迁移与材质转化能力',
        feature2Desc:
            '可基于参考图实现3D转平面、真实形象转插画/羊毛毡等风格化处理，并支持替换材质（如玻璃、冰块、机械），满足盲盒设计、IP衍生品开发等创意需求。',
        feature2Alt: 'Dreamina 4.0 风格迁移示例',

        feature3Title: '细节优化与商业级质感增强',
        feature3Desc:
            '针对人物面部肤质、服装褶皱、光影效果进行自然优化，保留皮肤纹理与细节的同时实现“精修级”处理，适配电商产品图、人像摄影等高质量输出场景。',
        feature3Alt: 'Dreamina 4.0 细节优化示例',

        feature4Title: '草图生成与实体化构建',
        feature4Desc:
            '能够根据手绘草图、线稿或文字描述生成高质量实体图像，如将老式电视机草图转化为写实图像，或依据姿势草图生成手办模型图，加速创意落地。',
        feature4Alt: 'Dreamina 4.0 草图生成示例',

        feature5Title: '多元素融合与故事化构图',
        feature5Desc:
            '支持将多个角色或物体按指定姿势合成至同一画面，生成连贯的故事分镜或场景组图，如“生成女孩和奶牛玩偶在游乐园坐过山车”，提升叙事表达能力。',
        feature5Alt: 'Dreamina 4.0 多元素融合示例',

        // How to Use
        howToUseTitle: '如何使用',
        howToUseSubtitle: '简单三步，开始创作',

        step1Title: '选择模型',
        step1Description: '在 AI 图像工具中选择 Dreamina 模型',

        step2Title: '输入内容',
        step2Description: '输入提示词或上传参考图像',

        step3Title: '生成图像',
        step3Description: '点击生成按钮，等待并下载您的图像',

        // YouTube Section
        youtubeTitle: '关于 Dreamina 4.0 图像模型的 YouTube 视频',

        // X Posts Section
        xPostsTitle: '关于 Dreamina 4.0 图像模型的 X 帖子',

        // Explore Models
        exploreModelsTitle: '在 微鲤AI 上探索其他 AI 图像模型',
        model1Title: 'Google Nano Banana AI Image Generator',
        model2Title: 'FLUX AI Image Generator',
        model3Title: 'Google Imagen AI Image Generator',

        // FAQ
        faqTitle: '常见问题',

        faq1Question: '即梦图片4.0适合哪些使用场景？',
        faq1Answer:
            '适用于电商商品图优化、艺术创作风格迁移、社交娱乐表情包生成、广告设计、IP形象开发等，尤其擅长处理需高精度控制的商业设计需求。',

        faq2Question: '模型能否理解复杂的多层编辑指令？',
        faq2Answer:
            '支持复合指令解析，如同时要求“改变视角+调整比例+参考风格”，模型会逐项解析并协同执行，确保输出符合预期。',

        faq3Question: '生成图像的分辨率和画质如何？',
        faq3Answer:
            '默认输出高清画质（可根据需求适配分辨率），并支持针对商业用途的细节增强选项，如人物肤质优化、光影修复等。',

        faq4Question: '是否支持基于草图或线稿的生成？',
        faq4Answer:
            '是的，模型可接受手绘草图、白板示意图（如数学公式板书）或线稿图作为输入，结合文本指令生成完整图像。',

        faq5Question: '如何控制生成图像与参考图的风格一致性？',
        faq5Answer:
            '通过“参考图片内容”等指令，模型可提取参考图的色调、笔触、材质等特征，确保输出风格高度一致，如将角色统一转为羊毛毡质感。',

        faq6Question: '能否生成系列组图或盲盒设计？',
        faq6Answer:
            '支持基于同一主题生成多张变体组图（如不同动物形象的盲盒设计），并保持风格统一，适合产品线扩展或内容系列化创作。',

        faq7Question: '模型在细节处理上如何平衡自然感与精细化？',
        faq7Answer:
            '通过算法对皮肤、纹理、光影进行优化时，会保留合理细节（如毛孔、布料褶皱），避免过度美化导致失真，确保画面自然且专业。',

        faq8Question: '是否有使用门槛或技术适配要求？',
        faq8Answer:
            '提供端到端的生成接口，用户无需专业设计背景，通过自然语言描述或草图+文本即可快速生成图像，支持API接入与平台集成。',

        // CTA Section
        ctaTitle: '立即开始使用 Dreamina 4.0',
        ctaDescription: '体验新一代 AI 图像生成技术，创造令人惊艳的视觉作品',
        ctaButton: '在WeryAI上尝试Dreamina',
        ctaDisclaimer: '无需信用卡，立即开始创作',
    },
    en: {
        // SEO Meta
        pageTitle: 'Dreamina 4.0 - Leading AI Image Generation Model',
        pageDescription:
            'Dreamina 4.0 is a next-generation AI image generation model offering cinematic quality, flexible editing, and professional-grade output. Supports text-to-image and image-to-image. Try it free on 微鲤AI.',
        pageKeywords:
            'Dreamina 4.0, AI image generation, text to image, image to image, AI art, image editing, cinematic rendering, 微鲤AI',
        ogTitle: 'Dreamina 4.0 AI Image Generator | 微鲤AI',
        ogDescription:
            'Dreamina 4.0 delivers cinematic quality AI image generation with diverse styles and professional editing capabilities',
        twitterTitle: 'Dreamina 4.0 - Professional AI Image Generation',
        twitterDescription:
            'Experience the power of Dreamina 4.0 for cinematic quality image generation with flexible editing',

        // Generator Section
        generatorTitle: 'Dreamina 4.0 AI Image Generator',
        generatorSubtitle:
            'Dreamina 4.0 by ByteDance is an AI image generation and editing model based on advanced multimodal technology, focusing on providing high-precision, high-freedom visual content generation for commercial design, art creation, and social entertainment. It supports complex instructions from sketch generation and style transfer to detail optimization and multi-image fusion, truly realizing "language-driven creation" to help individual creators and enterprises efficiently produce professional-grade visual content.',

        // Core Features
        coreFeaturesTitle: 'Dreamina 4.0 Core Features',
        coreFeaturesSubtitle:
            'Explore the powerful capabilities of Dreamina 4.0 and start your professional AI image creation journey',

        feature1Title: 'Multidimensional Control & Perspective Reconstruction',
        feature1Desc:
            'Supports flexible adjustments of perspective (e.g., eye-level to overhead), shot size (close-up to medium shot), and aspect ratio. Accurately responds to complex instructions like "change eye-level to overhead view, change close-up to medium shot," enhancing visual expressiveness and adaptability.',
        feature1Alt: 'Dreamina 4.0 multidimensional control example',

        feature2Title: 'Style Transfer & Material Conversion',
        feature2Desc:
            'Achieves stylized processing like 3D to 2D, realistic to illustration/felt based on reference images. Supports material replacement (e.g., glass, ice, mechanical), meeting creative needs for blind box design and IP derivative development.',
        feature2Alt: 'Dreamina 4.0 style transfer example',

        feature3Title: 'Detail Optimization & Commercial-Grade Texture',
        feature3Desc:
            'Naturally optimizes facial skin quality, clothing folds, and lighting effects. Achieves "retouch-level" processing while retaining skin texture and details, suitable for high-quality output scenarios like e-commerce product images and portrait photography.',
        feature3Alt: 'Dreamina 4.0 detail optimization example',

        feature4Title: 'Sketch Generation & Physical Construction',
        feature4Desc:
            'Generates high-quality physical images based on hand-drawn sketches, line art, or text descriptions. For example, transforming a sketch of an old TV into a realistic image, or generating a figure model based on a pose sketch, accelerating creative realization.',
        feature4Alt: 'Dreamina 4.0 sketch generation example',

        feature5Title: 'Multi-Element Fusion & Storytelling Composition',
        feature5Desc:
            'Supports synthesizing multiple characters or objects into the same scene with specified poses to generate coherent storyboards or scene groups. For example, "generate a girl and a cow doll riding a roller coaster at an amusement park," enhancing narrative expression capabilities.',
        feature5Alt: 'Dreamina 4.0 multi-element fusion example',

        // How to Use
        howToUseTitle: 'How to Use',
        howToUseSubtitle: 'Three simple steps to start creating',

        step1Title: 'Select Model',
        step1Description: 'Choose Dreamina model in AI image tools',

        step2Title: 'Input Content',
        step2Description: 'Enter prompts or upload reference images',

        step3Title: 'Generate Image',
        step3Description: 'Click generate button, wait and download your image',

        // YouTube Section
        youtubeTitle: 'YouTube Videos About Dreamina 4.0 Image Model',

        // X Posts Section
        xPostsTitle: 'X Posts About Dreamina 4.0 Image Model',

        // Explore Models
        exploreModelsTitle: 'Explore Other AI Image Models on 微鲤AI',
        model1Title: 'Google Nano Banana AI Image Generator',
        model2Title: 'FLUX AI Image Generator',
        model3Title: 'Google Imagen AI Image Generator',

        // FAQ
        faqTitle: 'Frequently Asked Questions',

        faq1Question: 'What scenarios is Dreamina 4.0 suitable for?',
        faq1Answer:
            'Suitable for e-commerce product image optimization, artistic style transfer, social entertainment meme generation, ad design, IP character development, etc., especially excelling in commercial design needs requiring high-precision control.',

        faq2Question:
            'Can the model understand complex multi-layer editing instructions?',
        faq2Answer:
            'Supports compound instruction parsing, such as simultaneously requesting "change perspective + adjust ratio + reference style", the model parses item by item and executes collaboratively to ensure output meets expectations.',

        faq3Question:
            'How are the resolution and image quality of generated images?',
        faq3Answer:
            'Defaults to high-definition output (resolution adaptable based on needs), and supports detail enhancement options for commercial use, such as skin texture optimization and lighting repair.',

        faq4Question:
            'Does it support generation based on sketches or line art?',
        faq4Answer:
            'Yes, the model accepts hand-drawn sketches, whiteboard diagrams (like math formulas), or line art as input, generating complete images combined with text instructions.',

        faq5Question:
            'How to control style consistency between generated images and reference images?',
        faq5Answer:
            'Through instructions like "reference image content", the model extracts features like tone, brushwork, and material from the reference image to ensure highly consistent output style, such as unifying characters into felt texture.',

        faq6Question: 'Can it generate series groups or blind box designs?',
        faq6Answer:
            'Supports generating multiple variant groups based on the same theme (like blind box designs of different animal figures) while maintaining unified style, suitable for product line extension or serialized content creation.',

        faq7Question:
            'How does the model balance naturalness and refinement in detail processing?',
        faq7Answer:
            'When optimizing skin, texture, and lighting via algorithms, reasonable details (like pores, fabric folds) are retained to avoid distortion from over-beautification, ensuring natural and professional visuals.',

        faq8Question:
            'Are there any usage thresholds or technical adaptation requirements?',
        faq8Answer:
            'Provides end-to-end generation interfaces; users need no professional design background and can quickly generate images via natural language descriptions or sketch+text, supporting API access and platform integration.',

        // CTA Section
        ctaTitle: 'Start Using Dreamina 4.0 Now',
        ctaDescription:
            'Experience next-generation AI image generation technology and create stunning visual works',
        ctaButton: 'Try Dreamina on 微鲤AI',
        ctaDisclaimer: 'No credit card required, start creating now',
    },
    ja: {
        // SEO Meta
        pageTitle: 'Dreamina 4.0 - 最先端のAI画像生成モデル',
        pageDescription:
            'Dreamina 4.0は次世代のAI画像生成モデルで、映画品質、柔軟な編集機能、プロフェッショナルグレードの出力を提供します。テキストから画像、画像から画像をサポート。WeryAIで無料体験。',
        pageKeywords:
            'Dreamina 4.0, AI画像生成, テキストから画像, 画像から画像, AIアート, 画像編集, 映画品質レンダリング, 微鲤AI',
        ogTitle: 'Dreamina 4.0 AI画像ジェネレーター | 微鲤AI',
        ogDescription:
            'Dreamina 4.0は映画品質のAI画像生成を提供し、多様なスタイルとプロフェッショナルな編集機能を備えています',
        twitterTitle: 'Dreamina 4.0 - プロフェッショナルAI画像生成',
        twitterDescription:
            'Dreamina 4.0の強力な映画品質画像生成と柔軟な編集を体験',

        // Generator Section
        generatorTitle: 'Dreamina 4.0 AI画像ジェネレーター',
        generatorSubtitle:
            'Dreamina 4.0はByteDanceによる先進的なマルチモーダル技術に基づくAI画像生成・編集モデルであり、商業デザイン、芸術創作、ソーシャルエンターテイメント向けに高精度で自由度の高い視覚コンテンツ生成機能を提供することに注力しています。スケッチ生成やスタイル転送から、詳細の最適化や複数画像の融合などの複雑な指示をサポートし、「言語駆動の創作」を真に実現し、個人のクリエイターや企業がプロフェッショナルな視覚コンテンツを効率的に制作できるよう支援します。',

        // Core Features
        coreFeaturesTitle: 'Dreamina 4.0 コア機能',
        coreFeaturesSubtitle:
            'Dreamina 4.0の強力な機能を探索し、プロフェッショナルAI画像作成の旅を始めましょう',

        feature1Title: '多次元画面制御と視点再構築',
        feature1Desc:
            '画面視点（例：目の高さから頭上へ）、ショットサイズ（クローズアップからミディアムショット）、アスペクト比（カスタムフレーム）の柔軟な調整をサポートします。「目の高さを頭上ビューに変更、クローズアップをミディアムショットに変更」などの複雑な指示に正確に応答し、視覚的な表現力と適応性を高めます。',
        feature1Alt: 'Dreamina 4.0 多次元制御の例',

        feature2Title: 'スタイル転送と素材変換',
        feature2Desc:
            '参照画像に基づいて、3Dから2D、リアルからイラスト/フェルトなどのスタイル化処理を実現します。素材の置換（ガラス、氷、機械など）をサポートし、ブラインドボックスデザインやIP派生開発の創造的なニーズを満たします。',
        feature2Alt: 'Dreamina 4.0 スタイル転送の例',

        feature3Title: '詳細の最適化と商業グレードの質感',
        feature3Desc:
            '顔の肌質、服のしわ、照明効果を自然に最適化します。肌の質感と詳細を保持しながら「レタッチレベル」の処理を実現し、Eコマース製品画像やポートレート写真などの高品質な出力シナリオに適しています。',
        feature3Alt: 'Dreamina 4.0 詳細最適化の例',

        feature4Title: 'スケッチ生成と実体構築',
        feature4Desc:
            '手描きのスケッチ、線画、またはテキスト記述に基づいて高品質の実体画像を生成します。たとえば、古いテレビのスケッチをリアルな画像に変換したり、ポーズスケッチに基づいてフィギュアモデルを生成したりして、創造的な実現を加速します。',
        feature4Alt: 'Dreamina 4.0 スケッチ生成の例',

        feature5Title: '多要素融合とストーリーテリング構図',
        feature5Desc:
            '指定されたポーズで複数のキャラクターやオブジェクトを同じシーンに合成し、一貫したストーリーボードやシーングループを生成することをサポートします。たとえば、「遊園地でジェットコースターに乗っている女の子と牛の人形を生成する」など、物語の表現力を高めます。',
        feature5Alt: 'Dreamina 4.0 多要素融合の例',

        // How to Use
        howToUseTitle: '使用方法',
        howToUseSubtitle: '簡単な3ステップで作成開始',

        step1Title: 'モデルを選択',
        step1Description: 'AI画像ツールでDreaminaモデルを選択',

        step2Title: 'コンテンツを入力',
        step2Description: 'プロンプトを入力するか、参照画像をアップロード',

        step3Title: '画像を生成',
        step3Description: '生成ボタンをクリックし、待機してダウンロード',

        // YouTube Section
        youtubeTitle: 'Dreamina 4.0画像モデルに関するYouTube動画',

        // X Posts Section
        xPostsTitle: 'Dreamina 4.0画像モデルに関するX投稿',

        // Explore Models
        exploreModelsTitle: 'WeryAIで他のAI画像モデルを探索',
        model1Title: 'Google Nano Banana AI画像ジェネレーター',
        model2Title: 'FLUX AI画像ジェネレーター',
        model3Title: 'Google Imagen AI画像ジェネレーター',

        // FAQ
        faqTitle: 'よくある質問',

        faq1Question: 'Dreamina 4.0はどのようなシナリオに適していますか？',
        faq1Answer:
            'Eコマースの商品画像最適化、アートスタイルの転送、ソーシャルエンターテインメントミームの生成、広告デザイン、IPキャラクター開発などに適しており、特に高精度の制御が必要な商業デザインニーズに優れています。',

        faq2Question: 'モデルは複雑な多層編集指示を理解できますか？',
        faq2Answer:
            '「視点の変更+比率の調整+参考スタイル」のような複合指示の解析をサポートし、モデルは項目ごとに解析して協調実行し、出力が期待に沿うようにします。',

        faq3Question: '生成された画像の解像度と画質はどうですか？',
        faq3Answer:
            'デフォルトで高解像度出力（ニーズに応じて解像度適応可能）を行い、人物の肌質最適化やライティング修正などの商業利用向けのディテール強化オプションをサポートしています。',

        faq4Question: 'スケッチや線画に基づいた生成はサポートしていますか？',
        faq4Answer:
            'はい、モデルは手描きのスケッチ、ホワイトボードの図（数式の板書など）、または線画を入力として受け入れ、テキスト指示と組み合わせて完全な画像を生成できます。',

        faq5Question:
            '生成された画像と参考画像のスタイルの一貫性をどのように制御しますか？',
        faq5Answer:
            '「参考画像コンテンツ」などの指示を通じて、モデルは参考画像の色調、筆致、材質などの特徴を抽出し、キャラクターをフェルトの質感に統一するなど、出力スタイルの一貫性を確保します。',

        faq6Question:
            'シリーズグループ画像やブラインドボックスデザインを生成できますか？',
        faq6Answer:
            '同じテーマに基づいた複数のバリエーション（異なる動物のブラインドボックスデザインなど）の生成をサポートし、統一されたスタイルを維持するため、製品ラインの拡張やシリーズ化されたコンテンツ作成に適しています。',

        faq7Question:
            'モデルはディテール処理において自然さと精細さをどのようにバランスさせていますか？',
        faq7Answer:
            'アルゴリズムによる肌、テクスチャ、ライティングの最適化の際、合理的なディテール（毛穴、布のひだなど）を保持し、過度な美化による歪みを避け、自然でプロフェッショナルなビジュアルを確保します。',

        faq8Question: '使用の敷居や技術的な適応要件はありますか？',
        faq8Answer:
            'エンドツーエンドの生成インターフェースを提供しており、ユーザーは専門的なデザインの背景を必要とせず、自然言語の説明やスケッチ+テキストですばやく画像を生成でき、APIアクセスとプラットフォーム統合をサポートしています。',

        // CTA Section
        ctaTitle: '今すぐDreamina 4.0を使い始めましょう',
        ctaDescription:
            '次世代AI画像生成技術を体験し、素晴らしいビジュアル作品を作成',
        ctaButton: 'WeryAIでDreaminaを試す',
        ctaDisclaimer: 'クレジットカード不要、今すぐ作成開始',
    },
    ko: {
        // SEO Meta
        pageTitle: 'Dreamina 4.0 - 선도적인 AI 이미지 생성 모델',
        pageDescription:
            'Dreamina 4.0은 영화급 품질, 유연한 편집 기능 및 전문가 수준의 출력을 제공하는 차세대 AI 이미지 생성 모델입니다. 텍스트에서 이미지, 이미지에서 이미지를 지원합니다. WeryAI에서 무료로 체험하세요.',
        pageKeywords:
            'Dreamina 4.0, AI 이미지 생성, 텍스트에서 이미지, 이미지에서 이미지, AI 아트, 이미지 편집, 영화급 렌더링, 微鲤AI',
        ogTitle: 'Dreamina 4.0 AI 이미지 생성기 | 微鲤AI',
        ogDescription:
            'Dreamina 4.0은 다양한 스타일과 전문적인 편집 기능으로 영화급 품질의 AI 이미지 생성을 제공합니다',
        twitterTitle: 'Dreamina 4.0 - 전문가급 AI 이미지 생성',
        twitterDescription:
            '유연한 편집으로 영화급 품질 이미지 생성을 위한 Dreamina 4.0의 강력함을 경험하세요',

        // Generator Section
        generatorTitle: 'Dreamina 4.0 AI 이미지 생성기',
        generatorSubtitle:
            'ByteDance의 Dreamina 4.0은 고급 멀티모달 기술을 기반으로 한 AI 이미지 생성 및 편집 모델로, 상업 디자인, 예술 창작 및 소셜 엔터테인먼트 시나리오를 위한 고정밀, 고자유도 시각 콘텐츠 생성 기능을 제공하는 데 중점을 둡니다. 스케치 생성 및 스타일 변환에서 세부 최적화 및 다중 이미지 융합에 이르는 복잡한 명령을 지원하여 "언어 주도 창작"을 진정으로 실현하고 개인 창작자와 기업이 전문적인 시각 콘텐츠를 효율적으로 제작할 수 있도록 돕습니다。',

        // Core Features
        coreFeaturesTitle: 'Dreamina 4.0 핵심 기능',
        coreFeaturesSubtitle:
            'Dreamina 4.0의 강력한 기능을 탐색하고 전문가급 AI 이미지 생성 여정을 시작하세요',

        feature1Title: '다차원 화면 제어 및 시점 재구성',
        feature1Desc:
            '화면 시점(예: 눈높이에서 오버헤드로), 샷 크기(클로즈업에서 미디엄 샷), 화면비(사용자 지정 프레임)의 유연한 조정을 지원합니다. "눈높이 시점을 오버헤드 뷰로 변경, 클로즈업을 미디엄 샷으로 변경"과 같은 복잡한 지시사항에 정확하게 반응하여 시각적 표현력과 적응성을 향상시킵니다.',
        feature1Alt: 'Dreamina 4.0 다차원 제어 예시',

        feature2Title: '스타일 변환 및 재질 변환',
        feature2Desc:
            '참조 이미지를 기반으로 3D에서 2D로, 사실적인 것에서 일러스트/펠트로 스타일화 처리를 실현합니다. 재질 교체(예: 유리, 얼음, 기계)를 지원하여 블라인드 박스 디자인 및 IP 파생 개발의 창의적 요구를 충족합니다.',
        feature2Alt: 'Dreamina 4.0 스타일 변환 예시',

        feature3Title: '세부 최적화 및 상업용 등급 질감',
        feature3Desc:
            '얼굴 피부 질감, 의류 주름, 조명 효과를 자연스럽게 최적화합니다. 피부 질감과 세부 사항을 유지하면서 "리터칭 수준" 처리를 실현하여 전자 상거래 제품 이미지 및 인물 사진과 같은 고품질 출력 시나리오에 적합합니다.',
        feature3Alt: 'Dreamina 4.0 세부 최적화 예시',

        feature4Title: '스케치 생성 및 실체 구축',
        feature4Desc:
            '손으로 그린 스케치, 라인 아트 또는 텍스트 설명을 기반으로 고품질 실체 이미지를 생성합니다. 예를 들어 오래된 TV의 스케치를 사실적인 이미지로 변환하거나 포즈 스케치를 기반으로 피규어 모델을 생성하여 창의적 실현을 가속화합니다.',
        feature4Alt: 'Dreamina 4.0 스케치 생성 예시',

        feature5Title: '다중 요소 융합 및 스토리텔링 구도',
        feature5Desc:
            '지정된 포즈로 여러 캐릭터나 객체를 동일한 장면에 합성하여 일관된 스토리보드나 장면 그룹을 생성하도록 지원합니다. 예를 들어 "놀이공원에서 롤러코스터를 타는 소녀와 소 인형 생성"과 같이 서사적 표현 능력을 향상시킵니다.',
        feature5Alt: 'Dreamina 4.0 다중 요소 융합 예시',

        // How to Use
        howToUseTitle: '사용 방법',
        howToUseSubtitle: '간단한 3단계로 창작 시작',

        step1Title: '모델 선택',
        step1Description: 'AI 이미지 도구에서 Dreamina 모델 선택',

        step2Title: '콘텐츠 입력',
        step2Description: '프롬프트를 입력하거나 참조 이미지 업로드',

        step3Title: '이미지 생성',
        step3Description: '생성 버튼을 클릭하고 대기 후 다운로드',

        // YouTube Section
        youtubeTitle: 'Dreamina 4.0 이미지 모델에 관한 YouTube 동영상',

        // X Posts Section
        xPostsTitle: 'Dreamina 4.0 이미지 모델에 관한 X 게시물',

        // Explore Models
        exploreModelsTitle: 'WeryAI에서 다른 AI 이미지 모델 탐색',
        model1Title: 'Google Nano Banana AI 이미지 생성기',
        model2Title: 'FLUX AI 이미지 생성기',
        model3Title: 'Google Imagen AI 이미지 생성기',

        // FAQ
        faqTitle: '자주 묻는 질문',

        faq1Question: 'Dreamina 4.0은 어떤 시나리오에 적합한가요?',
        faq1Answer:
            '전자상거래 제품 이미지 최적화, 예술적 스타일 변환, 소셜 엔터테인먼트 밈 생성, 광고 디자인, IP 캐릭터 개발 등에 적합하며, 특히 고정밀 제어가 필요한 상업적 디자인 요구에 탁월합니다.',

        faq2Question: '모델이 복잡한 다층 편집 지침을 이해할 수 있나요?',
        faq2Answer:
            '"시점 변경 + 비율 조정 + 참조 스타일"과 같은 복합 지침 구문 분석을 지원하며, 모델은 항목별로 분석하고 협력하여 실행하여 출력이 기대에 부합하도록 합니다.',

        faq3Question: '생성된 이미지의 해상도와 화질은 어떤가요?',
        faq3Answer:
            '기본적으로 고화질 출력(요구에 따라 해상도 조정 가능)을 지원하며, 인물 피부 질감 최적화 및 조명 수정을 포함한 상업용 세부 사항 향상 옵션을 지원합니다.',

        faq4Question: '스케치나 선화 기반의 생성을 지원하나요?',
        faq4Answer:
            '네, 모델은 손으로 그린 스케치, 화이트보드 다이어그램(수학 공식 판서 등) 또는 선화를 입력으로 받아 텍스트 지침과 결합하여 완전한 이미지를 생성할 수 있습니다.',

        faq5Question:
            '생성된 이미지와 참조 이미지 간의 스타일 일관성을 어떻게 제어하나요?',
        faq5Answer:
            '"참조 이미지 콘텐츠"와 같은 지침을 통해 모델은 참조 이미지의 톤, 붓터치, 재질 등의 특징을 추출하여 캐릭터를 펠트 질감으로 통일하는 등 출력 스타일의 높은 일관성을 보장합니다.',

        faq6Question:
            '시리즈 그룹 이미지나 블라인드 박스 디자인을 생성할 수 있나요?',
        faq6Answer:
            '동일한 주제를 기반으로 여러 변형 그룹(다른 동물 피규어의 블라인드 박스 디자인 등) 생성을 지원하며 통일된 스타일을 유지하여 제품 라인 확장이나 시리즈 콘텐츠 제작에 적합합니다.',

        faq7Question:
            '모델은 세부 처리에서 자연스러움과 정교함의 균형을 어떻게 맞추나요?',
        faq7Answer:
            '알고리즘을 통한 피부, 질감, 조명 최적화 시, 합리적인 세부 사항(모공, 천 주름 등)을 유지하여 과도한 미화로 인한 왜곡을 방지하고 자연스럽고 전문적인 비주얼을 보장합니다.',

        faq8Question: '사용 임계값이나 기술적 적응 요구 사항이 있나요?',
        faq8Answer:
            '엔드투엔드 생성 인터페이스를 제공하여 사용자는 전문적인 디자인 배경이 없어도 자연어 설명이나 스케치+텍스트로 빠르게 이미지를 생성할 수 있으며 API 액세스 및 플랫폼 통합을 지원합니다.',

        // CTA Section
        ctaTitle: '지금 Dreamina 4.0 사용 시작',
        ctaDescription:
            '차세대 AI 이미지 생성 기술을 경험하고 멋진 시각 작품 제작',
        ctaButton: 'WeryAI에서 Dreamina 시도',
        ctaDisclaimer: '신용카드 불필요, 지금 바로 창작 시작',
    },
    tw: {
        // SEO Meta
        pageTitle: 'Dreamina 4.0 - 领先的 AI 图像生成模型',
        pageDescription:
            'Dreamina 4.0 是新一代 AI 图像生成模型，提供电影级质量、灵活编辑功能和专业级输出。支持文生图和图生图，立即在 微鲤AI 免费体验。',
        pageKeywords:
            'Dreamina 4.0, AI图像生成, 文生图, 图生图, AI绘画, 图像编辑, 电影级渲染, 微鲤AI',
        ogTitle: 'Dreamina 4.0 AI 图像生成器 | 微鲤AI',
        ogDescription:
            'Dreamina 4.0 提供电影级质量的 AI 图像生成，支持多样化风格和专业级编辑功能',
        twitterTitle: 'Dreamina 4.0 - 专业级 AI 图像生成',
        twitterDescription:
            '体验 Dreamina 4.0 的强大图像生成能力，电影级质量，灵活编辑',

        // Generator Section
        generatorTitle: 'Dreamina 4.0 AI 图像生成器',
        generatorSubtitle:
            '即梦4.0 （Dreamina 4.0）是字节跳动的一款基于先进多模态技术的AI图像生成与编辑模型，专注于为商业设计、艺术创作与社交娱乐场景提供高精度、高自由度的视觉内容生成能力。支持从草图生成、风格迁移到细节优化、多图融合等复杂指令，真正实现“语言驱动创作”，助力个人创作者与企业高效产出专业级视觉内容。',

        // Core Features
        coreFeaturesTitle: 'Dreamina 4.0 核心功能',
        coreFeaturesSubtitle:
            '探索 Dreamina 4.0 的强大功能，开启专业级 AI 图像创作之旅',

        feature1Title: '多维度画面控制与视角重构',
        feature1Desc:
            '支持对画面视角（如平视转俯视）、景别（近景转中景）、比例（自定义画幅）进行灵活调整，精准响应如“将平视视角改为俯视视角，将近景改为中景”等复杂指令，增强画面表现力与适配性。',
        feature1Alt: 'Dreamina 4.0 多维度画面控制示例',

        feature2Title: '风格迁移与材质转化能力',
        feature2Desc:
            '可基于参考图实现3D转平面、真实形象转插画/羊毛毡等风格化处理，并支持替换材质（如玻璃、冰块、机械），满足盲盒设计、IP衍生品开发等创意需求。',
        feature2Alt: 'Dreamina 4.0 风格迁移示例',

        feature3Title: '细节优化与商业级质感增强',
        feature3Desc:
            '针对人物面部肤质、服装褶皱、光影效果进行自然优化，保留皮肤纹理与细节的同时实现“精修级”处理，适配电商产品图、人像摄影等高质量输出场景。',
        feature3Alt: 'Dreamina 4.0 细节优化示例',

        feature4Title: '草图生成与实体化构建',
        feature4Desc:
            '能够根据手绘草图、线稿或文字描述生成高质量实体图像，如将老式电视机草图转化为写实图像，或依据姿势草图生成手办模型图，加速创意落地。',
        feature4Alt: 'Dreamina 4.0 草图生成示例',

        feature5Title: '多元素融合与故事化构图',
        feature5Desc:
            '支持将多个角色或物体按指定姿势合成至同一画面，生成连贯的故事分镜或场景组图，如“生成女孩和奶牛玩偶在游乐园坐过山车”，提升叙事表达能力。',
        feature5Alt: 'Dreamina 4.0 多元素融合示例',

        // How to Use
        howToUseTitle: '如何使用',
        howToUseSubtitle: '简单三步，开始创作',

        step1Title: '选择模型',
        step1Description: '在 AI 图像工具中选择 Dreamina 模型',

        step2Title: '输入内容',
        step2Description: '输入提示词或上传参考图像',

        step3Title: '生成图像',
        step3Description: '点击生成按钮，等待并下载您的图像',

        // YouTube Section
        youtubeTitle: '关于 Dreamina 4.0 图像模型的 YouTube 视频',

        // X Posts Section
        xPostsTitle: '关于 Dreamina 4.0 图像模型的 X 帖子',

        // Explore Models
        exploreModelsTitle: '在 微鲤AI 上探索其他 AI 图像模型',
        model1Title: 'Google Nano Banana AI Image Generator',
        model2Title: 'FLUX AI Image Generator',
        model3Title: 'Google Imagen AI Image Generator',

        // FAQ
        faqTitle: '常见问题',

        faq1Question: '即梦图片4.0适合哪些使用场景？',
        faq1Answer:
            '适用于电商商品图优化、艺术创作风格迁移、社交娱乐表情包生成、广告设计、IP形象开发等，尤其擅长处理需高精度控制的商业设计需求。',

        faq2Question: '模型能否理解复杂的多层编辑指令？',
        faq2Answer:
            '支持复合指令解析，如同时要求“改变视角+调整比例+参考风格”，模型会逐项解析并协同执行，确保输出符合预期。',

        faq3Question: '生成图像的分辨率和画质如何？',
        faq3Answer:
            '默认输出高清画质（可根据需求适配分辨率），并支持针对商业用途的细节增强选项，如人物肤质优化、光影修复等。',

        faq4Question: '是否支持基于草图或线稿的生成？',
        faq4Answer:
            '是的，模型可接受手绘草图、白板示意图（如数学公式板书）或线稿图作为输入，结合文本指令生成完整图像。',

        faq5Question: '如何控制生成图像与参考图的风格一致性？',
        faq5Answer:
            '通过“参考图片内容”等指令，模型可提取参考图的色调、笔触、材质等特征，确保输出风格高度一致，如将角色统一转为羊毛毡质感。',

        faq6Question: '能否生成系列组图或盲盒设计？',
        faq6Answer:
            '支持基于同一主题生成多张变体组图（如不同动物形象的盲盒设计），并保持风格统一，适合产品线扩展或内容系列化创作。',

        faq7Question: '模型在细节处理上如何平衡自然感与精细化？',
        faq7Answer:
            '通过算法对皮肤、纹理、光影进行优化时，会保留合理细节（如毛孔、布料褶皱），避免过度美化导致失真，确保画面自然且专业。',

        faq8Question: '是否有使用门槛或技术适配要求？',
        faq8Answer:
            '提供端到端的生成接口，用户无需专业设计背景，通过自然语言描述或草图+文本即可快速生成图像，支持API接入与平台集成。',

        // CTA Section
        ctaTitle: '立即开始使用 Dreamina 4.0',
        ctaDescription: '体验新一代 AI 图像生成技术，创造令人惊艳的视觉作品',
        ctaButton: '在WeryAI上尝试Dreamina',
        ctaDisclaimer: '无需信用卡，立即开始创作',
    },
    pl: {
        // SEO Meta
        pageTitle: 'Dreamina 4.0 - Leading AI Image Generation Model',
        pageDescription:
            'Dreamina 4.0 is a next-generation AI image generation model offering cinematic quality, flexible editing, and professional-grade output. Supports text-to-image and image-to-image. Try it free on 微鲤AI.',
        pageKeywords:
            'Dreamina 4.0, AI image generation, text to image, image to image, AI art, image editing, cinematic rendering, 微鲤AI',
        ogTitle: 'Dreamina 4.0 AI Image Generator | 微鲤AI',
        ogDescription:
            'Dreamina 4.0 delivers cinematic quality AI image generation with diverse styles and professional editing capabilities',
        twitterTitle: 'Dreamina 4.0 - Professional AI Image Generation',
        twitterDescription:
            'Experience the power of Dreamina 4.0 for cinematic quality image generation with flexible editing',

        // Generator Section
        generatorTitle: 'Dreamina 4.0 AI Image Generator',
        generatorSubtitle:
            'Dreamina 4.0 by ByteDance is an AI image generation and editing model based on advanced multimodal technology, focusing on providing high-precision, high-freedom visual content generation for commercial design, art creation, and social entertainment. It supports complex instructions from sketch generation and style transfer to detail optimization and multi-image fusion, truly realizing "language-driven creation" to help individual creators and enterprises efficiently produce professional-grade visual content.',

        // Core Features
        coreFeaturesTitle: 'Dreamina 4.0 Core Features',
        coreFeaturesSubtitle:
            'Explore the powerful capabilities of Dreamina 4.0 and start your professional AI image creation journey',

        feature1Title: 'Multidimensional Control & Perspective Reconstruction',
        feature1Desc:
            'Supports flexible adjustments of perspective (e.g., eye-level to overhead), shot size (close-up to medium shot), and aspect ratio. Accurately responds to complex instructions like "change eye-level to overhead view, change close-up to medium shot," enhancing visual expressiveness and adaptability.',
        feature1Alt: 'Dreamina 4.0 multidimensional control example',

        feature2Title: 'Style Transfer & Material Conversion',
        feature2Desc:
            'Achieves stylized processing like 3D to 2D, realistic to illustration/felt based on reference images. Supports material replacement (e.g., glass, ice, mechanical), meeting creative needs for blind box design and IP derivative development.',
        feature2Alt: 'Dreamina 4.0 style transfer example',

        feature3Title: 'Detail Optimization & Commercial-Grade Texture',
        feature3Desc:
            'Naturally optimizes facial skin quality, clothing folds, and lighting effects. Achieves "retouch-level" processing while retaining skin texture and details, suitable for high-quality output scenarios like e-commerce product images and portrait photography.',
        feature3Alt: 'Dreamina 4.0 detail optimization example',

        feature4Title: 'Sketch Generation & Physical Construction',
        feature4Desc:
            'Generates high-quality physical images based on hand-drawn sketches, line art, or text descriptions. For example, transforming a sketch of an old TV into a realistic image, or generating a figure model based on a pose sketch, accelerating creative realization.',
        feature4Alt: 'Dreamina 4.0 sketch generation example',

        feature5Title: 'Multi-Element Fusion & Storytelling Composition',
        feature5Desc:
            'Supports synthesizing multiple characters or objects into the same scene with specified poses to generate coherent storyboards or scene groups. For example, "generate a girl and a cow doll riding a roller coaster at an amusement park," enhancing narrative expression capabilities.',
        feature5Alt: 'Dreamina 4.0 multi-element fusion example',

        // How to Use
        howToUseTitle: 'How to Use',
        howToUseSubtitle: 'Three simple steps to start creating',

        step1Title: 'Select Model',
        step1Description: 'Choose Dreamina model in AI image tools',

        step2Title: 'Input Content',
        step2Description: 'Enter prompts or upload reference images',

        step3Title: 'Generate Image',
        step3Description: 'Click generate button, wait and download your image',

        // YouTube Section
        youtubeTitle: 'YouTube Videos About Dreamina 4.0 Image Model',

        // X Posts Section
        xPostsTitle: 'X Posts About Dreamina 4.0 Image Model',

        // Explore Models
        exploreModelsTitle: 'Explore Other AI Image Models on 微鲤AI',
        model1Title: 'Google Nano Banana AI Image Generator',
        model2Title: 'FLUX AI Image Generator',
        model3Title: 'Google Imagen AI Image Generator',

        // FAQ
        faqTitle: 'Frequently Asked Questions',

        faq1Question: 'What scenarios is Dreamina 4.0 suitable for?',
        faq1Answer:
            'Suitable for e-commerce product image optimization, artistic style transfer, social entertainment meme generation, ad design, IP character development, etc., especially excelling in commercial design needs requiring high-precision control.',

        faq2Question:
            'Can the model understand complex multi-layer editing instructions?',
        faq2Answer:
            'Supports compound instruction parsing, such as simultaneously requesting "change perspective + adjust ratio + reference style", the model parses item by item and executes collaboratively to ensure output meets expectations.',

        faq3Question:
            'How are the resolution and image quality of generated images?',
        faq3Answer:
            'Defaults to high-definition output (resolution adaptable based on needs), and supports detail enhancement options for commercial use, such as skin texture optimization and lighting repair.',

        faq4Question:
            'Does it support generation based on sketches or line art?',
        faq4Answer:
            'Yes, the model accepts hand-drawn sketches, whiteboard diagrams (like math formulas), or line art as input, generating complete images combined with text instructions.',

        faq5Question:
            'How to control style consistency between generated images and reference images?',
        faq5Answer:
            'Through instructions like "reference image content", the model extracts features like tone, brushwork, and material from the reference image to ensure highly consistent output style, such as unifying characters into felt texture.',

        faq6Question: 'Can it generate series groups or blind box designs?',
        faq6Answer:
            'Supports generating multiple variant groups based on the same theme (like blind box designs of different animal figures) while maintaining unified style, suitable for product line extension or serialized content creation.',

        faq7Question:
            'How does the model balance naturalness and refinement in detail processing?',
        faq7Answer:
            'When optimizing skin, texture, and lighting via algorithms, reasonable details (like pores, fabric folds) are retained to avoid distortion from over-beautification, ensuring natural and professional visuals.',

        faq8Question:
            'Are there any usage thresholds or technical adaptation requirements?',
        faq8Answer:
            'Provides end-to-end generation interfaces; users need no professional design background and can quickly generate images via natural language descriptions or sketch+text, supporting API access and platform integration.',

        // CTA Section
        ctaTitle: 'Start Using Dreamina 4.0 Now',
        ctaDescription:
            'Experience next-generation AI image generation technology and create stunning visual works',
        ctaButton: 'Try Dreamina on 微鲤AI',
        ctaDisclaimer: 'No credit card required, start creating now',
    },
    es: {
        // SEO Meta
        pageTitle: 'Dreamina 4.0 - Modelo Líder de Generación de Imágenes IA',
        pageDescription:
            'Dreamina 4.0 es un modelo de generación de imágenes IA de próxima generación que ofrece calidad cinematográfica, edición flexible y salida de nivel profesional. Compatible con texto a imagen e imagen a imagen. Pruébalo gratis en 微鲤AI.',
        pageKeywords:
            'Dreamina 4.0, generación de imágenes IA, texto a imagen, imagen a imagen, arte IA, edición de imágenes, renderizado cinematográfico, 微鲤AI',
        ogTitle: 'Generador de Imágenes IA Dreamina 4.0 | 微鲤AI',
        ogDescription:
            'Dreamina 4.0 ofrece generación de imágenes IA de calidad cinematográfica con estilos diversos y capacidades de edición profesionales',
        twitterTitle: 'Dreamina 4.0 - Generación Profesional de Imágenes IA',
        twitterDescription:
            'Experimenta el poder de Dreamina 4.0 para generación de imágenes de calidad cinematográfica con edición flexible',

        // Generator Section
        generatorTitle: 'Generador de Imágenes IA Dreamina 4.0',
        generatorSubtitle:
            'Dreamina 4.0 de ByteDance es un modelo de generación y edición de imágenes por IA basado en tecnología multimodal avanzada, enfocado en proporcionar capacidades de generación de contenido visual de alta precisión y libertad para el diseño comercial, la creación artística y el entretenimiento social. Admite instrucciones complejas desde la generación de bocetos y transferencia de estilo hasta la optimización de detalles y fusión de múltiples imágenes, realizando verdaderamente la "creación impulsada por el lenguaje" para ayudar a los creadores individuales y empresas a producir contenido visual de nivel profesional de manera eficiente.',

        // Core Features
        coreFeaturesTitle: 'Características Principales de Dreamina 4.0',
        coreFeaturesSubtitle:
            'Explora las poderosas capacidades de Dreamina 4.0 e inicia tu viaje de creación de imágenes IA profesionales',

        feature1Title:
            'Control Multidimensional y Reconstrucción de Perspectiva',
        feature1Desc:
            'Admite ajustes flexibles de perspectiva (por ejemplo, del nivel de los ojos a una vista aérea), tamaño del plano (primer plano a plano medio) y relación de aspecto (marco personalizado). Responde con precisión a instrucciones complejas como "cambiar vista al nivel de los ojos a vista aérea, cambiar primer plano a plano medio", mejorando la expresividad visual y la adaptabilidad.',
        feature1Alt: 'Ejemplo de control multidimensional de Dreamina 4.0',

        feature2Title: 'Transferencia de Estilo y Conversión de Materiales',
        feature2Desc:
            'Logra un procesamiento estilizado como de 3D a 2D, realista a ilustración/fieltro basado en imágenes de referencia. Admite el reemplazo de materiales (por ejemplo, vidrio, hielo, mecánico), satisfaciendo las necesidades creativas para el diseño de cajas sorpresa y el desarrollo de derivados de IP.',
        feature2Alt: 'Ejemplo de transferencia de estilo de Dreamina 4.0',

        feature3Title: 'Optimización de Detalles y Textura de Grado Comercial',
        feature3Desc:
            'Optimiza naturalmente la calidad de la piel facial, los pliegues de la ropa y los efectos de iluminación. Logra un procesamiento de "nivel de retoque" conservando la textura y los detalles de la piel, adecuado para escenarios de salida de alta calidad como imágenes de productos de comercio electrónico y fotografía de retratos.',
        feature3Alt: 'Ejemplo de optimización de detalles de Dreamina 4.0',

        feature4Title: 'Generación de Bocetos y Construcción Física',
        feature4Desc:
            'Genera imágenes físicas de alta calidad basadas en bocetos dibujados a mano, arte lineal o descripciones de texto. Por ejemplo, transformar un boceto de un televisor antiguo en una imagen realista o generar un modelo de figura basado en un boceto de pose, acelerando la realización creativa.',
        feature4Alt: 'Ejemplo de generación de bocetos de Dreamina 4.0',

        feature5Title: 'Fusión de Múltiples Elementos y Composición Narrativa',
        feature5Desc:
            'Admite sintetizar múltiples personajes u objetos en la misma escena con poses específicas para generar guiones gráficos coherentes o grupos de escenas. Por ejemplo, "generar una niña y una muñeca de vaca montando una montaña rusa en un parque de atracciones", mejorando las capacidades de expresión narrativa.',
        feature5Alt: 'Ejemplo de fusión de múltiples elementos de Dreamina 4.0',

        // How to Use
        howToUseTitle: 'Cómo Usar',
        howToUseSubtitle: 'Tres simples pasos para comenzar a crear',

        step1Title: 'Seleccionar Modelo',
        step1Description:
            'Elige el modelo Dreamina en herramientas de imágenes IA',

        step2Title: 'Ingresar Contenido',
        step2Description: 'Ingresa prompts o sube imágenes de referencia',

        step3Title: 'Generar Imagen',
        step3Description:
            'Haz clic en el botón de generar, espera y descarga tu imagen',

        // YouTube Section
        youtubeTitle:
            'Videos de YouTube Sobre el Modelo de Imagen Dreamina 4.0',

        // X Posts Section
        xPostsTitle: 'Publicaciones X Sobre el Modelo de Imagen Dreamina 4.0',

        // Explore Models
        exploreModelsTitle: 'Explora Otros Modelos de Imágenes IA en 微鲤AI',
        model1Title: 'Generador de Imágenes IA Google Nano Banana',
        model2Title: 'Generador de Imágenes IA FLUX',
        model3Title: 'Generador de Imágenes IA Google Imagen',

        // FAQ
        faqTitle: 'Preguntas Frecuentes',

        faq1Question: '¿Para qué escenarios es adecuado Dreamina 4.0?',
        faq1Answer:
            'Es adecuado para la optimización de imágenes de productos de comercio electrónico, transferencia de estilos artísticos, generación de memes para entretenimiento social, diseño publicitario, desarrollo de personajes IP, etc., destacando especialmente en necesidades de diseño comercial que requieren control de alta precisión.',

        faq2Question:
            '¿Puede el modelo entender instrucciones de edición complejas de múltiples capas?',
        faq2Answer:
            'Soporta el análisis de instrucciones compuestas, como solicitar simultáneamente "cambiar perspectiva + ajustar proporción + estilo de referencia", el modelo analiza elemento por elemento y ejecuta de manera colaborativa para asegurar que la salida cumpla con las expectativas.',

        faq3Question:
            '¿Cómo son la resolución y la calidad de imagen de las imágenes generadas?',
        faq3Answer:
            'Por defecto ofrece salida en alta definición (resolución adaptable según necesidades), y soporta opciones de mejora de detalles para uso comercial, como optimización de textura de piel y reparación de iluminación.',

        faq4Question: '¿Soporta la generación basada en bocetos o arte lineal?',
        faq4Answer:
            'Sí, el modelo acepta bocetos hechos a mano, diagramas de pizarra (como fórmulas matemáticas) o arte lineal como entrada, generando imágenes completas combinadas con instrucciones de texto.',

        faq5Question:
            '¿Cómo controlar la consistencia de estilo entre las imágenes generadas y las imágenes de referencia?',
        faq5Answer:
            'A través de instrucciones como "contenido de imagen de referencia", el modelo extrae características como tono, pincelada y material de la imagen de referencia para asegurar una alta consistencia de estilo en la salida, como unificar personajes en textura de fieltro.',

        faq6Question:
            '¿Puede generar grupos de series o diseños de cajas ciegas?',
        faq6Answer:
            'Soporta generar múltiples grupos de variantes basados en el mismo tema (como diseños de cajas ciegas de diferentes figuras de animales) manteniendo un estilo unificado, adecuado para extensión de línea de productos o creación de contenido serializado.',

        faq7Question:
            '¿Cómo equilibra el modelo la naturalidad y el refinamiento en el procesamiento de detalles?',
        faq7Answer:
            'Al optimizar piel, textura e iluminación mediante algoritmos, se retienen detalles razonables (como poros, pliegues de tela) para evitar distorsión por embellecimiento excesivo, asegurando visuales naturales y profesionales.',

        faq8Question:
            '¿Existen umbrales de uso o requisitos de adaptación técnica?',
        faq8Answer:
            'Proporciona interfaces de generación de extremo a extremo; los usuarios no necesitan experiencia profesional en diseño y pueden generar imágenes rápidamente mediante descripciones en lenguaje natural o boceto+texto, soportando acceso API e integración de plataforma.',

        // CTA Section
        ctaTitle: 'Comienza a Usar Dreamina 4.0 Ahora',
        ctaDescription:
            'Experimenta la tecnología de generación de imágenes IA de próxima generación y crea obras visuales impresionantes',
        ctaButton: 'Prueba Dreamina en 微鲤AI',
        ctaDisclaimer:
            'No se requiere tarjeta de crédito, comienza a crear ahora',
    },
    fr: {
        // SEO Meta
        pageTitle: "Dreamina 4.0 - Modèle Leader de Génération d'Images IA",
        pageDescription:
            "Dreamina 4.0 est un modèle de génération d'images IA de nouvelle génération offrant une qualité cinématographique, une édition flexible et une sortie de qualité professionnelle. Prend en charge texte vers image et image vers image. Essayez-le gratuitement sur 微鲤AI.",
        pageKeywords:
            "Dreamina 4.0, génération d'images IA, texte vers image, image vers image, art IA, édition d'images, rendu cinématographique, 微鲤AI",
        ogTitle: "Générateur d'Images IA Dreamina 4.0 | 微鲤AI",
        ogDescription:
            "Dreamina 4.0 offre une génération d'images IA de qualité cinématographique avec des styles divers et des capacités d'édition professionnelles",
        twitterTitle: "Dreamina 4.0 - Génération Professionnelle d'Images IA",
        twitterDescription:
            "Découvrez la puissance de Dreamina 4.0 pour la génération d'images de qualité cinématographique avec édition flexible",

        // Generator Section
        generatorTitle: "Générateur d'Images IA Dreamina 4.0",
        generatorSubtitle:
            "Dreamina 4.0 de ByteDance est un modèle de génération et d'édition d'images IA basé sur une technologie multimodale avancée, se concentrant sur la fourniture de capacités de génération de contenu visuel de haute précision et de grande liberté pour la conception commerciale, la création artistique et le divertissement social. Il prend en charge des instructions complexes allant de la génération d'esquisses et du transfert de style à l'optimisation des détails et à la fusion de plusieurs images, réalisant véritablement la \"création pilotée par le langage\" pour aider les créateurs individuels et les entreprises à produire efficacement du contenu visuel de niveau professionnel.",

        // Core Features
        coreFeaturesTitle: 'Fonctionnalités Principales de Dreamina 4.0',
        coreFeaturesSubtitle:
            "Explorez les puissantes capacités de Dreamina 4.0 et commencez votre voyage de création d'images IA professionnelles",

        feature1Title:
            'Contrôle Multidimensionnel et Reconstruction de Perspective',
        feature1Desc:
            "Prend en charge des ajustements flexibles de la perspective (par exemple, du niveau des yeux à la vue de dessus), de la taille du plan (gros plan à plan moyen) et du format d'image (cadre personnalisé). Répond avec précision à des instructions complexes telles que \"changer la vue au niveau des yeux en vue de dessus, changer le gros plan en plan moyen\", améliorant l'expressivité visuelle et l'adaptabilité.",
        feature1Alt: 'Exemple de contrôle multidimensionnel de Dreamina 4.0',

        feature2Title: 'Transfert de Style et Conversion de Matériaux',
        feature2Desc:
            "Réalise un traitement stylisé comme la 3D vers la 2D, le réaliste vers l'illustration/feutre basé sur des images de référence. Prend en charge le remplacement de matériaux (par exemple, verre, glace, mécanique), répondant aux besoins créatifs pour la conception de boîtes mystères et le développement de dérivés de PI.",
        feature2Alt: 'Exemple de transfert de style de Dreamina 4.0',

        feature3Title:
            'Optimisation des Détails et Texture de Qualité Commerciale',
        feature3Desc:
            'Optimise naturellement la qualité de la peau du visage, les plis des vêtements et les effets d\'éclairage. Réalise un traitement de "niveau retouche" tout en conservant la texture et les détails de la peau, adapté aux scénarios de sortie de haute qualité tels que les images de produits e-commerce et la photographie de portrait.',
        feature3Alt: "Exemple d'optimisation des détails de Dreamina 4.0",

        feature4Title: "Génération d'Esquisses et Construction Physique",
        feature4Desc:
            "Génère des images physiques de haute qualité basées sur des esquisses dessinées à la main, des dessins au trait ou des descriptions textuelles. Par exemple, transformer une esquisse d'une vieille télévision en une image réaliste, ou générer un modèle de figurine basé sur une esquisse de pose, accélérant la réalisation créative.",
        feature4Alt: "Exemple de génération d'esquisses de Dreamina 4.0",

        feature5Title: 'Fusion Multi-Éléments et Composition Narrative',
        feature5Desc:
            'Prend en charge la synthèse de plusieurs personnages ou objets dans la même scène avec des poses spécifiées pour générer des storyboards cohérents ou des groupes de scènes. Par exemple, "générer une fille et une poupée vache sur des montagnes russes dans un parc d\'attractions", améliorant les capacités d\'expression narrative.',
        feature5Alt: 'Exemple de fusion multi-éléments de Dreamina 4.0',

        // How to Use
        howToUseTitle: 'Comment Utiliser',
        howToUseSubtitle: 'Trois étapes simples pour commencer à créer',

        step1Title: 'Sélectionner le Modèle',
        step1Description:
            "Choisissez le modèle Dreamina dans les outils d'images IA",

        step2Title: 'Saisir le Contenu',
        step2Description:
            'Entrez des prompts ou téléchargez des images de référence',

        step3Title: "Générer l'Image",
        step3Description:
            'Cliquez sur le bouton générer, attendez et téléchargez votre image',

        // YouTube Section
        youtubeTitle: "Vidéos YouTube Sur le Modèle d'Image Dreamina 4.0",

        // X Posts Section
        xPostsTitle: "Publications X Sur le Modèle d'Image Dreamina 4.0",

        // Explore Models
        exploreModelsTitle: "Explorez d'Autres Modèles d'Images IA sur 微鲤AI",
        model1Title: "Générateur d'Images IA Google Nano Banana",
        model2Title: "Générateur d'Images IA FLUX",
        model3Title: "Générateur d'Images IA Google Imagen",

        // FAQ
        faqTitle: 'Questions Fréquemment Posées',

        faq1Question: 'Pour quels scénarios Dreamina 4.0 est-il adapté ?',
        faq1Answer:
            "Il convient à l'optimisation d'images de produits de commerce électronique, au transfert de style artistique, à la génération de mèmes de divertissement social, à la conception publicitaire, au développement de personnages IP, etc., excellant particulièrement dans les besoins de conception commerciale nécessitant un contrôle de haute précision.",

        faq2Question:
            "Le modèle peut-il comprendre des instructions d'édition complexes à plusieurs niveaux ?",
        faq2Answer:
            "Il prend en charge l'analyse d'instructions composées, telles que la demande simultanée de \"changer de perspective + ajuster le rapport + style de référence\", le modèle analyse élément par élément et exécute en collaboration pour s'assurer que la sortie répond aux attentes.",

        faq3Question:
            "Comment sont la résolution et la qualité d'image des images générées ?",
        faq3Answer:
            "Par défaut, il offre une sortie haute définition (résolution adaptable selon les besoins) et prend en charge des options d'amélioration des détails pour un usage commercial, telles que l'optimisation de la texture de la peau et la réparation de l'éclairage.",

        faq4Question:
            'Prend-il en charge la génération basée sur des croquis ou des dessins au trait ?',
        faq4Answer:
            'Oui, le modèle accepte des croquis faits à la main, des diagrammes sur tableau blanc (comme des formules mathématiques) ou des dessins au trait comme entrée, générant des images complètes combinées à des instructions textuelles.',

        faq5Question:
            'Comment contrôler la cohérence de style entre les images générées et les images de référence ?',
        faq5Answer:
            "Grâce à des instructions telles que \"contenu de l'image de référence\", le modèle extrait des caractéristiques telles que le ton, le coup de pinceau et la matière de l'image de référence pour assurer une cohérence de style élevée dans la sortie, comme l'unification des personnages en texture de feutre.",

        faq6Question:
            'Peut-il générer des groupes de séries ou des designs de boîtes mystères ?',
        faq6Answer:
            "Il prend en charge la génération de plusieurs groupes de variantes basés sur le même thème (comme des designs de boîtes mystères de différentes figures animales) tout en maintenant un style unifié, adapté à l'extension de la gamme de produits ou à la création de contenu sérialisé.",

        faq7Question:
            'Comment le modèle équilibre-t-il le naturel et le raffinement dans le traitement des détails ?',
        faq7Answer:
            "Lors de l'optimisation de la peau, de la texture et de l'éclairage par algorithmes, des détails raisonnables (comme les pores, les plis du tissu) sont conservés pour éviter la distorsion due à une embellissement excessif, garantissant des visuels naturels et professionnels.",

        faq8Question:
            "Existe-t-il des seuils d'utilisation ou des exigences d'adaptation technique ?",
        faq8Answer:
            "Il fournit des interfaces de génération de bout en bout ; les utilisateurs n'ont pas besoin d'expérience professionnelle en design et peuvent générer rapidement des images via des descriptions en langage naturel ou croquis+texte, prenant en charge l'accès API et l'intégration de plateforme.",

        // CTA Section
        ctaTitle: 'Commencez à Utiliser Dreamina 4.0 Maintenant',
        ctaDescription:
            "Découvrez la technologie de génération d'images IA de nouvelle génération et créez des œuvres visuelles époustouflantes",
        ctaButton: 'Essayez Dreamina sur 微鲤AI',
        ctaDisclaimer:
            'Aucune carte de crédit requise, commencez à créer maintenant',
    },
    de: {
        // SEO Meta
        pageTitle: 'Dreamina 4.0 - Führendes KI-Bildgenerierungsmodell',
        pageDescription:
            'Dreamina 4.0 ist ein KI-Bildgenerierungsmodell der nächsten Generation, das filmische Qualität, flexible Bearbeitung und professionelle Ausgabe bietet. Unterstützt Text-zu-Bild und Bild-zu-Bild. Kostenlos auf 微鲤AI ausprobieren.',
        pageKeywords:
            'Dreamina 4.0, KI-Bildgenerierung, Text zu Bild, Bild zu Bild, KI-Kunst, Bildbearbeitung, filmisches Rendering, 微鲤AI',
        ogTitle: 'Dreamina 4.0 KI-Bildgenerator | 微鲤AI',
        ogDescription:
            'Dreamina 4.0 liefert filmische Qualität bei der KI-Bildgenerierung mit vielfältigen Stilen und professionellen Bearbeitungsfunktionen',
        twitterTitle: 'Dreamina 4.0 - Professionelle KI-Bildgenerierung',
        twitterDescription:
            'Erleben Sie die Leistung von Dreamina 4.0 für filmische Qualität bei der Bildgenerierung mit flexibler Bearbeitung',

        // Generator Section
        generatorTitle: 'Dreamina 4.0 KI-Bildgenerator',
        generatorSubtitle:
            'Dreamina 4.0 von ByteDance ist ein KI-Bildgenerierungs- und Bearbeitungsmodell, das auf fortschrittlicher multimodaler Technologie basiert und sich darauf konzentriert, hochpräzise und hochfreie visuelle Inhaltsgenerierungsfunktionen für kommerzielles Design, Kunstschaffen und soziale Unterhaltung bereitzustellen. Es unterstützt komplexe Anweisungen von der Skizzenerstellung und Stilübertragung bis hin zur Detailoptimierung und Multi-Image-Fusion, realisiert wirklich "sprachgesteuerte Kreation" und hilft einzelnen Schöpfern und Unternehmen, professionelle visuelle Inhalte effizient zu produzieren.',

        // Core Features
        coreFeaturesTitle: 'Dreamina 4.0 Kernfunktionen',
        coreFeaturesSubtitle:
            'Entdecken Sie die leistungsstarken Funktionen von Dreamina 4.0 und starten Sie Ihre professionelle KI-Bilderstellungsreise',

        feature1Title: 'Multidimensionale Steuerung & Perspektivrekonstruktion',
        feature1Desc:
            'Unterstützt flexible Anpassungen der Perspektive (z. B. Augenhöhe zu Draufsicht), Aufnahmegröße (Nahaufnahme zu Halbnahaufnahme) und Seitenverhältnis (benutzerdefinierter Rahmen). Reagiert präzise auf komplexe Anweisungen wie "Augenhöhe in Draufsicht ändern, Nahaufnahme in Halbnahaufnahme ändern", was die visuelle Ausdruckskraft und Anpassungsfähigkeit verbessert.',
        feature1Alt:
            'Beispiel für multidimensionale Steuerung von Dreamina 4.0',

        feature2Title: 'Stilübertragung & Materialumwandlung',
        feature2Desc:
            'Erzielt stilisierte Verarbeitung wie 3D zu 2D, realistisch zu Illustration/Filz basierend auf Referenzbildern. Unterstützt den Materialaustausch (z. B. Glas, Eis, mechanisch) und erfüllt kreative Bedürfnisse für Blind-Box-Design und IP-Derivatentwicklung.',
        feature2Alt: 'Beispiel für Stilübertragung von Dreamina 4.0',

        feature3Title: 'Detailoptimierung & Textur in kommerzieller Qualität',
        feature3Desc:
            'Optimiert auf natürliche Weise die Qualität der Gesichtshaut, Falten in der Kleidung und Lichteffekte. Erzielt eine Verarbeitung auf "Retusche-Niveau", während Hauttextur und Details erhalten bleiben, geeignet für hochwertige Ausgabeszenarien wie E-Commerce-Produktbilder und Porträtfotografie.',
        feature3Alt: 'Beispiel für Detailoptimierung von Dreamina 4.0',

        feature4Title: 'Skizzenerstellung & physische Konstruktion',
        feature4Desc:
            'Generiert hochwertige physische Bilder basierend auf handgezeichneten Skizzen, Strichzeichnungen oder Textbeschreibungen. Zum Beispiel Umwandlung einer Skizze eines alten Fernsehers in ein realistisches Bild oder Erstellung eines Figurenmodells basierend auf einer Posenskizze, was die kreative Umsetzung beschleunigt.',
        feature4Alt: 'Beispiel für Skizzenerstellung von Dreamina 4.0',

        feature5Title: 'Multi-Element-Fusion & Storytelling-Komposition',
        feature5Desc:
            'Unterstützt die Synthese mehrerer Charaktere oder Objekte in derselben Szene mit festgelegten Posen, um kohärente Storyboards oder Szenengruppen zu erstellen. Zum Beispiel "Erstelle ein Mädchen und eine Kuhpuppe, die in einem Freizeitpark Achterbahn fahren", was die narrativen Ausdrucksfähigkeiten verbessert.',
        feature5Alt: 'Beispiel für Multi-Element-Fusion von Dreamina 4.0',

        // How to Use
        howToUseTitle: 'Verwendung',
        howToUseSubtitle: 'Drei einfache Schritte zum Erstellen',

        step1Title: 'Modell Auswählen',
        step1Description: 'Wählen Sie das Dreamina-Modell in KI-Bildwerkzeugen',

        step2Title: 'Inhalt Eingeben',
        step2Description: 'Prompts eingeben oder Referenzbilder hochladen',

        step3Title: 'Bild Generieren',
        step3Description:
            'Auf Generieren klicken, warten und Ihr Bild herunterladen',

        // YouTube Section
        youtubeTitle: 'YouTube-Videos Über das Dreamina 4.0 Bildmodell',

        // X Posts Section
        xPostsTitle: 'X-Beiträge Über das Dreamina 4.0 Bildmodell',

        // Explore Models
        exploreModelsTitle: 'Entdecken Sie Andere KI-Bildmodelle auf 微鲤AI',
        model1Title: 'Google Nano Banana KI-Bildgenerator',
        model2Title: 'FLUX KI-Bildgenerator',
        model3Title: 'Google Imagen KI-Bildgenerator',

        // FAQ
        faqTitle: 'Häufig Gestellte Fragen',

        faq1Question: 'Für welche Szenarien ist Dreamina 4.0 geeignet?',
        faq1Answer:
            'Es eignet sich für die Optimierung von E-Commerce-Produktbildern, die Übertragung künstlerischer Stile, die Erstellung von Social-Entertainment-Memes, Werbedesign, IP-Charakterentwicklung usw. und zeichnet sich besonders bei kommerziellen Designanforderungen aus, die eine hochpräzise Steuerung erfordern.',

        faq2Question:
            'Kann das Modell komplexe mehrschichtige Bearbeitungsanweisungen verstehen?',
        faq2Answer:
            'Unterstützt das Parsen zusammengesetzter Anweisungen, wie z. B. gleichzeitige Anforderung von "Perspektive ändern + Verhältnis anpassen + Referenzstil", das Modell analysiert Element für Element und führt sie kollaborativ aus, um sicherzustellen, dass die Ausgabe den Erwartungen entspricht.',

        faq3Question:
            'Wie sind Auflösung und Bildqualität der generierten Bilder?',
        faq3Answer:
            'Standardmäßig bietet es hochauflösende Ausgabe (Auflösung je nach Bedarf anpassbar) und unterstützt Detailverbesserungsoptionen für den kommerziellen Gebrauch, wie z. B. Optimierung der Hauttextur und Lichtreparatur.',

        faq4Question:
            'Unterstützt es die Generierung basierend auf Skizzen oder Strichzeichnungen?',
        faq4Answer:
            'Ja, das Modell akzeptiert handgezeichnete Skizzen, Whiteboard-Diagramme (wie mathematische Formeln) oder Strichzeichnungen als Eingabe und generiert vollständige Bilder in Kombination mit Textanweisungen.',

        faq5Question:
            'Wie steuert man die Stilkonsistenz zwischen generierten Bildern und Referenzbildern?',
        faq5Answer:
            'Durch Anweisungen wie "Referenzbildinhalt" extrahiert das Modell Merkmale wie Ton, Pinselstrich und Material aus dem Referenzbild, um eine hohe Stilkonsistenz in der Ausgabe zu gewährleisten, wie z. B. die Vereinheitlichung von Charakteren in Filztextur.',

        faq6Question:
            'Kann es Seriengruppen oder Blind-Box-Designs generieren?',
        faq6Answer:
            'Unterstützt die Generierung mehrerer Variantengruppen basierend auf demselben Thema (wie Blind-Box-Designs verschiedener Tierfiguren) unter Beibehaltung eines einheitlichen Stils, geeignet für Produktlinienerweiterung oder serialisierte Inhaltserstellung.',

        faq7Question:
            'Wie balanciert das Modell Natürlichkeit und Verfeinerung bei der Detailverarbeitung?',
        faq7Answer:
            'Bei der Optimierung von Haut, Textur und Beleuchtung durch Algorithmen werden vernünftige Details (wie Poren, Stofffalten) beibehalten, um Verzerrungen durch übermäßige Verschönerung zu vermeiden und natürliche und professionelle Visuals zu gewährleisten.',

        faq8Question:
            'Gibt es Nutzungsschwellen oder technische Anpassungsanforderungen?',
        faq8Answer:
            'Bietet End-to-End-Generierungsschnittstellen; Benutzer benötigen keinen professionellen Designhintergrund und können Bilder schnell über Beschreibungen in natürlicher Sprache oder Skizze+Text generieren, unterstützt API-Zugriff und Plattformintegration.',

        // CTA Section
        ctaTitle: 'Beginnen Sie Jetzt mit Dreamina 4.0',
        ctaDescription:
            'Erleben Sie die KI-Bildgenerierungstechnologie der nächsten Generation und erstellen Sie atemberaubende visuelle Werke',
        ctaButton: 'Testen Sie Dreamina auf 微鲤AI',
        ctaDisclaimer:
            'Keine Kreditkarte erforderlich, jetzt mit dem Erstellen beginnen',
    },
    ru: {
        // SEO Meta
        pageTitle: 'Dreamina 4.0 - Ведущая Модель Генерации Изображений ИИ',
        pageDescription:
            'Dreamina 4.0 - это модель генерации изображений ИИ нового поколения, предлагающая кинематографическое качество, гибкое редактирование и профессиональный вывод. Поддерживает текст в изображение и изображение в изображение. Попробуйте бесплатно на 微鲤AI.',
        pageKeywords:
            'Dreamina 4.0, генерация изображений ИИ, текст в изображение, изображение в изображение, ИИ-арт, редактирование изображений, кинематографический рендеринг, 微鲤AI',
        ogTitle: 'Генератор Изображений ИИ Dreamina 4.0 | 微鲤AI',
        ogDescription:
            'Dreamina 4.0 обеспечивает генерацию изображений ИИ кинематографического качества с разнообразными стилями и профессиональными возможностями редактирования',
        twitterTitle:
            'Dreamina 4.0 - Профессиональная Генерация Изображений ИИ',
        twitterDescription:
            'Ощутите мощь Dreamina 4.0 для генерации изображений кинематографического качества с гибким редактированием',

        // Generator Section
        generatorTitle: 'Генератор Изображений ИИ Dreamina 4.0',
        generatorSubtitle:
            'Dreamina 4.0 от ByteDance — это модель генерации и редактирования изображений ИИ на основе передовых мультимодальных технологий, ориентированная на предоставление возможностей создания визуального контента высокой точности и свободы для коммерческого дизайна, художественного творчества и социальных развлечений. Она поддерживает сложные инструкции от генерации эскизов и переноса стиля до оптимизации деталей и слияния нескольких изображений, по-настоящему реализуя «творчество, управляемое языком», чтобы помочь индивидуальным авторам и предприятиям эффективно создавать визуальный контент профессионального уровня.',

        // Core Features
        coreFeaturesTitle: 'Основные Функции Dreamina 4.0',
        coreFeaturesSubtitle:
            'Исследуйте мощные возможности Dreamina 4.0 и начните свое путешествие по профессиональному созданию изображений ИИ',

        feature1Title: 'Многомерный Контроль и Реконструкция Перспективы',
        feature1Desc:
            'Поддерживает гибкие настройки перспективы (например, с уровня глаз на вид сверху), размера кадра (крупный план на средний план) и соотношения сторон (пользовательский кадр). Точно реагирует на сложные инструкции, такие как «изменить вид с уровня глаз на вид сверху, изменить крупный план на средний план», улучшая визуальную выразительность и адаптивность.',
        feature1Alt: 'Пример многомерного контроля Dreamina 4.0',

        feature2Title: 'Перенос Стиля и Преобразование Материалов',
        feature2Desc:
            'Обеспечивает стилизованную обработку, такую как 3D в 2D, реалистичное в иллюстрацию/войлок на основе эталонных изображений. Поддерживает замену материалов (например, стекло, лед, механический), удовлетворяя творческие потребности для дизайна слепых коробок и разработки производных IP.',
        feature2Alt: 'Пример переноса стиля Dreamina 4.0',

        feature3Title: 'Оптимизация Деталей и Текстура Коммерческого Класса',
        feature3Desc:
            'Естественно оптимизирует качество кожи лица, складки одежды и световые эффекты. Достигает обработки «уровня ретуши», сохраняя текстуру кожи и детали, подходит для сценариев высококачественного вывода, таких как изображения продуктов электронной коммерции и портретная фотография.',
        feature3Alt: 'Пример оптимизации деталей Dreamina 4.0',

        feature4Title: 'Генерация Эскизов и Физическое Построение',
        feature4Desc:
            'Генерирует высококачественные физические изображения на основе нарисованных от руки эскизов, штриховых рисунков или текстовых описаний. Например, преобразование эскиза старого телевизора в реалистичное изображение или создание модели фигурки на основе эскиза позы, ускоряя творческую реализацию.',
        feature4Alt: 'Пример генерации эскизов Dreamina 4.0',

        feature5Title:
            'Слияние Нескольких Элементов и Повествовательная Композиция',
        feature5Desc:
            'Поддерживает синтез нескольких персонажей или объектов в одной сцене с заданными позами для создания последовательных раскадровок или групп сцен. Например, «создать девочку и куклу-корову, катающихся на американских горках в парке развлечений», улучшая возможности повествовательного выражения.',
        feature5Alt: 'Пример слияния нескольких элементов Dreamina 4.0',

        // How to Use
        howToUseTitle: 'Как Использовать',
        howToUseSubtitle: 'Три простых шага для начала создания',

        step1Title: 'Выбрать Модель',
        step1Description:
            'Выберите модель Dreamina в инструментах изображений ИИ',

        step2Title: 'Ввести Контент',
        step2Description:
            'Введите подсказки или загрузите эталонные изображения',

        step3Title: 'Сгенерировать Изображение',
        step3Description:
            'Нажмите кнопку генерации, подождите и загрузите свое изображение',

        // YouTube Section
        youtubeTitle: 'Видео YouTube О Модели Изображений Dreamina 4.0',

        // X Posts Section
        xPostsTitle: 'Публикации X О Модели Изображений Dreamina 4.0',

        // Explore Models
        exploreModelsTitle: 'Изучите Другие Модели Изображений ИИ на 微鲤AI',
        model1Title: 'Генератор Изображений ИИ Google Nano Banana',
        model2Title: 'Генератор Изображений ИИ FLUX',
        model3Title: 'Генератор Изображений ИИ Google Imagen',

        // FAQ
        faqTitle: 'Часто Задаваемые Вопросы',

        faq1Question: 'Для каких сценариев подходит Dreamina 4.0?',
        faq1Answer:
            'Подходит для оптимизации изображений продуктов электронной коммерции, переноса художественного стиля, создания мемов для социального развлечения, рекламного дизайна, разработки персонажей IP и т.д., особенно выделяясь в коммерческих дизайнерских задачах, требующих высокоточного контроля.',

        faq2Question:
            'Может ли модель понимать сложные многослойные инструкции по редактированию?',
        faq2Answer:
            'Поддерживает парсинг составных инструкций, например, одновременный запрос «изменить перспективу + настроить соотношение + эталонный стиль», модель анализирует элемент за элементом и выполняет их совместно, чтобы гарантировать соответствие результата ожиданиям.',

        faq3Question: 'Каково разрешение и качество генерируемых изображений?',
        faq3Answer:
            'По умолчанию обеспечивает вывод высокой четкости (разрешение адаптируется в зависимости от потребностей) и поддерживает опции улучшения деталей для коммерческого использования, такие как оптимизация текстуры кожи и исправление освещения.',

        faq4Question:
            'Поддерживает ли генерацию на основе набросков или штриховых рисунков?',
        faq4Answer:
            'Да, модель принимает нарисованные от руки наброски, диаграммы на белой доске (например, математические формулы) или штриховые рисунки в качестве входных данных, генерируя полные изображения в сочетании с текстовыми инструкциями.',

        faq5Question:
            'Как контролировать согласованность стиля между сгенерированными изображениями и эталонными изображениями?',
        faq5Answer:
            'С помощью инструкций, таких как «контент эталонного изображения», модель извлекает такие характеристики, как тон, мазок кисти и материал из эталонного изображения, чтобы обеспечить высокую согласованность стиля на выходе, например, унификацию персонажей в текстуре войлока.',

        faq6Question:
            'Может ли она генерировать группы серий или дизайны слепых коробок?',
        faq6Answer:
            'Поддерживает генерацию нескольких групп вариантов на основе одной темы (например, дизайны слепых коробок с разными фигурками животных) при сохранении единого стиля, что подходит для расширения продуктовой линейки или создания сериализованного контента.',

        faq7Question:
            'Как модель балансирует естественность и утонченность при обработке деталей?',
        faq7Answer:
            'При оптимизации кожи, текстуры и освещения с помощью алгоритмов сохраняются разумные детали (такие как поры, складки ткани), чтобы избежать искажений из-за чрезмерного украшения, обеспечивая естественные и профессиональные визуальные эффекты.',

        faq8Question:
            'Существуют ли пороги использования или требования к технической адаптации?',
        faq8Answer:
            'Предоставляет интерфейсы генерации полного цикла; пользователям не требуется профессиональный дизайнерский опыт, и они могут быстро генерировать изображения с помощью описаний на естественном языке или наброска+текста, поддерживая доступ через API и интеграцию с платформой.',

        // CTA Section
        ctaTitle: 'Начните Использовать Dreamina 4.0 Сейчас',
        ctaDescription:
            'Испытайте технологию генерации изображений ИИ нового поколения и создавайте потрясающие визуальные работы',
        ctaButton: 'Попробуйте Dreamina на 微鲤AI',
        ctaDisclaimer: 'Кредитная карта не требуется, начните создавать сейчас',
    },
    pt: {
        // SEO Meta
        pageTitle: 'Dreamina 4.0 - Modelo Líder de Geração de Imagens IA',
        pageDescription:
            'Dreamina 4.0 é um modelo de geração de imagens IA de próxima geração que oferece qualidade cinematográfica, edição flexível e saída de nível profissional. Suporta texto para imagem e imagem para imagem. Experimente grátis no 微鲤AI.',
        pageKeywords:
            'Dreamina 4.0, geração de imagens IA, texto para imagem, imagem para imagem, arte IA, edição de imagens, renderização cinematográfica, 微鲤AI',
        ogTitle: 'Gerador de Imagens IA Dreamina 4.0 | 微鲤AI',
        ogDescription:
            'Dreamina 4.0 oferece geração de imagens IA de qualidade cinematográfica com estilos diversos e recursos de edição profissionais',
        twitterTitle: 'Dreamina 4.0 - Geração Profissional de Imagens IA',
        twitterDescription:
            'Experimente o poder do Dreamina 4.0 para geração de imagens de qualidade cinematográfica com edição flexível',

        // Generator Section
        generatorTitle: 'Gerador de Imagens IA Dreamina 4.0',
        generatorSubtitle:
            'Dreamina 4.0 da ByteDance é um modelo de geração e edição de imagens de IA baseado em tecnologia multimodal avançada, focado em fornecer recursos de geração de conteúdo visual de alta precisão e alta liberdade para design comercial, criação artística e entretenimento social. Suporta instruções complexas, desde geração de esboços e transferência de estilo até otimização de detalhes e fusão de várias imagens, realizando verdadeiramente a "criação impulsionada pela linguagem" para ajudar criadores individuais e empresas a produzir conteúdo visual de nível profissional de forma eficiente.',

        // Core Features
        coreFeaturesTitle: 'Recursos Principais do Dreamina 4.0',
        coreFeaturesSubtitle:
            'Explore os recursos poderosos do Dreamina 4.0 e inicie sua jornada de criação de imagens IA profissionais',

        feature1Title:
            'Controle Multidimensional e Reconstrução de Perspectiva',
        feature1Desc:
            'Suporta ajustes flexíveis de perspectiva (por exemplo, nível dos olhos para vista aérea), tamanho do plano (close-up para plano médio) e proporção (quadro personalizado). Responde com precisão a instruções complexas como "mudar vista ao nível dos olhos para vista aérea, mudar close-up para plano médio", melhorando a expressividade visual e a adaptabilidade.',
        feature1Alt: 'Exemplo de controle multidimensional do Dreamina 4.0',

        feature2Title: 'Transferência de Estilo e Conversão de Materiais',
        feature2Desc:
            'Realiza processamento estilizado como 3D para 2D, realista para ilustração/feltro com base em imagens de referência. Suporta substituição de materiais (por exemplo, vidro, gelo, mecânico), atendendo às necessidades criativas para design de caixas surpresa e desenvolvimento de derivados de IP.',
        feature2Alt: 'Exemplo de transferência de estilo do Dreamina 4.0',

        feature3Title: 'Otimização de Detalhes e Textura de Grau Comercial',
        feature3Desc:
            'Otimiza naturalmente a qualidade da pele facial, dobras de roupas e efeitos de iluminação. Atinge processamento de "nível de retoque" preservando a textura e os detalhes da pele, adequado para cenários de saída de alta qualidade, como imagens de produtos de comércio eletrônico e fotografia de retratos.',
        feature3Alt: 'Exemplo de otimização de detalhes do Dreamina 4.0',

        feature4Title: 'Geração de Esboços e Construção Física',
        feature4Desc:
            'Gera imagens físicas de alta qualidade com base em esboços desenhados à mão, arte linear ou descrições de texto. Por exemplo, transformar um esboço de uma TV antiga em uma imagem realista ou gerar um modelo de figura com base em um esboço de pose, acelerando a realização criativa.',
        feature4Alt: 'Exemplo de geração de esboços do Dreamina 4.0',

        feature5Title: 'Fusão de Múltiplos Elementos e Composição Narrativa',
        feature5Desc:
            'Suporta sintetizar múltiplos personagens ou objetos na mesma cena com poses especificadas para gerar storyboards coerentes ou grupos de cenas. Por exemplo, "gerar uma menina e uma boneca de vaca andando em uma montanha-russa em um parque de diversões", aprimorando as capacidades de expressão narrativa.',
        feature5Alt: 'Exemplo de fusão de múltiplos elementos do Dreamina 4.0',

        // How to Use
        howToUseTitle: 'Como Usar',
        howToUseSubtitle: 'Três passos simples para começar a criar',

        step1Title: 'Selecionar Modelo',
        step1Description:
            'Escolha o modelo Dreamina nas ferramentas de imagens IA',

        step2Title: 'Inserir Conteúdo',
        step2Description: 'Insira prompts ou carregue imagens de referência',

        step3Title: 'Gerar Imagem',
        step3Description: 'Clique no botão gerar, aguarde e baixe sua imagem',

        // YouTube Section
        youtubeTitle: 'Vídeos do YouTube Sobre o Modelo de Imagem Dreamina 4.0',

        // X Posts Section
        xPostsTitle: 'Publicações X Sobre o Modelo de Imagem Dreamina 4.0',

        // Explore Models
        exploreModelsTitle: 'Explore Outros Modelos de Imagens IA no 微鲤AI',
        model1Title: 'Gerador de Imagens IA Google Nano Banana',
        model2Title: 'Gerador de Imagens IA FLUX',
        model3Title: 'Gerador de Imagens IA Google Imagen',

        // FAQ
        faqTitle: 'Perguntas Frequentes',

        faq1Question: 'Para quais cenários o Dreamina 4.0 é adequado?',
        faq1Answer:
            'É adequado para otimização de imagens de produtos de comércio eletrônico, transferência de estilo artístico, geração de memes para entretenimento social, design publicitário, desenvolvimento de personagens IP, etc., destacando-se especialmente em necessidades de design comercial que exigem controle de alta precisão.',

        faq2Question:
            'O modelo pode entender instruções de edição complexas em várias camadas?',
        faq2Answer:
            'Suporta a análise de instruções compostas, como solicitar simultaneamente "mudar perspectiva + ajustar proporção + estilo de referência", o modelo analisa item por item e executa de forma colaborativa para garantir que a saída atenda às expectativas.',

        faq3Question:
            'Como são a resolução e a qualidade da imagem das imagens geradas?',
        faq3Answer:
            'Por padrão, oferece saída em alta definição (resolução adaptável de acordo com as necessidades) e suporta opções de aprimoramento de detalhes para uso comercial, como otimização de textura da pele e reparo de iluminação.',

        faq4Question: 'Suporta geração baseada em esboços ou arte linear?',
        faq4Answer:
            'Sim, o modelo aceita esboços feitos à mão, diagramas de quadro branco (como fórmulas matemáticas) ou arte linear como entrada, gerando imagens completas combinadas com instruções de texto.',

        faq5Question:
            'Como controlar a consistência de estilo entre as imagens geradas e as imagens de referência?',
        faq5Answer:
            'Através de instruções como "conteúdo da imagem de referência", o modelo extrai características como tom, pincelada e material da imagem de referência para garantir alta consistência de estilo na saída, como unificar personagens em textura de feltro.',

        faq6Question: 'Pode gerar grupos de séries ou designs de caixas cegas?',
        faq6Answer:
            'Suporta gerar vários grupos de variantes com base no mesmo tema (como designs de caixas cegas de diferentes figuras de animais) mantendo um estilo unificado, adequado para extensão de linha de produtos ou criação de conteúdo serializado.',

        faq7Question:
            'Como o modelo equilibra naturalidade e refinamento no processamento de detalhes?',
        faq7Answer:
            'Ao otimizar pele, textura e iluminação por meio de algoritmos, detalhes razoáveis (como poros, dobras de tecido) são mantidos para evitar distorção por embelezamento excessivo, garantindo visuais naturais e profissionais.',

        faq8Question:
            'Existem limites de uso ou requisitos de adaptação técnica?',
        faq8Answer:
            'Fornece interfaces de geração de ponta a ponta; os usuários não precisam de experiência profissional em design e podem gerar imagens rapidamente por meio de descrições em linguagem natural ou esboço+texto, suportando acesso à API e integração de plataforma.',

        // CTA Section
        ctaTitle: 'Comece a Usar Dreamina 4.0 Agora',
        ctaDescription:
            'Experimente a tecnologia de geração de imagens IA de próxima geração e crie obras visuais impressionantes',
        ctaButton: 'Experimente Dreamina no 微鲤AI',
        ctaDisclaimer:
            'Não é necessário cartão de crédito, comece a criar agora',
    },
    it: {
        // SEO Meta
        pageTitle: 'Dreamina 4.0 - Modello Leader di Generazione Immagini IA',
        pageDescription:
            'Dreamina 4.0 è un modello di generazione immagini IA di nuova generazione che offre qualità cinematografica, editing flessibile e output di livello professionale. Supporta testo a immagine e immagine a immagine. Provalo gratis su 微鲤AI.',
        pageKeywords:
            'Dreamina 4.0, generazione immagini IA, testo a immagine, immagine a immagine, arte IA, editing immagini, rendering cinematografico, 微鲤AI',
        ogTitle: 'Generatore di Immagini IA Dreamina 4.0 | 微鲤AI',
        ogDescription:
            'Dreamina 4.0 offre generazione di immagini IA di qualità cinematografica con stili diversi e capacità di editing professionali',
        twitterTitle: 'Dreamina 4.0 - Generazione Professionale di Immagini IA',
        twitterDescription:
            'Sperimenta la potenza di Dreamina 4.0 per la generazione di immagini di qualità cinematografica con editing flessibile',

        // Generator Section
        generatorTitle: 'Generatore di Immagini IA Dreamina 4.0',
        generatorSubtitle:
            'Dreamina 4.0 di ByteDance è un modello di generazione ed editing di immagini IA basato su una tecnologia multimodale avanzata, focalizzato sulla fornitura di capacità di generazione di contenuti visivi ad alta precisione e alta libertà per il design commerciale, la creazione artistica e l\'intrattenimento sociale. Supporta istruzioni complesse dalla generazione di schizzi e trasferimento di stile all\'ottimizzazione dei dettagli e alla fusione di più immagini, realizzando veramente la "creazione guidata dal linguaggio" per aiutare i creatori individuali e le imprese a produrre in modo efficiente contenuti visivi di livello professionale.',

        // Core Features
        coreFeaturesTitle: 'Caratteristiche Principali di Dreamina 4.0',
        coreFeaturesSubtitle:
            'Esplora le potenti capacità di Dreamina 4.0 e inizia il tuo viaggio di creazione di immagini IA professionali',

        feature1Title:
            'Controllo Multidimensionale e Ricostruzione della Prospettiva',
        feature1Desc:
            "Supporta regolazioni flessibili della prospettiva (ad esempio, livello degli occhi a vista dall'alto), dimensione dell'inquadratura (primo piano a piano medio) e proporzioni (cornice personalizzata). Risponde con precisione a istruzioni complesse come \"cambia vista a livello degli occhi in vista dall'alto, cambia primo piano in piano medio\", migliorando l'espressività visiva e l'adattabilità.",
        feature1Alt: 'Esempio di controllo multidimensionale di Dreamina 4.0',

        feature2Title: 'Trasferimento di Stile e Conversione di Materiali',
        feature2Desc:
            'Realizza elaborazione stilizzata come da 3D a 2D, realistico a illustrazione/feltro basato su immagini di riferimento. Supporta la sostituzione di materiali (ad esempio, vetro, ghiaccio, meccanico), soddisfacendo le esigenze creative per il design di scatole a sorpresa e lo sviluppo di derivati IP.',
        feature2Alt: 'Esempio di trasferimento di stile di Dreamina 4.0',

        feature3Title:
            'Ottimizzazione dei Dettagli e Texture di Grado Commerciale',
        feature3Desc:
            'Ottimizza naturalmente la qualità della pelle del viso, le pieghe dei vestiti e gli effetti di illuminazione. Ottiene un\'elaborazione di "livello ritocco" preservando la texture e i dettagli della pelle, adatta a scenari di output di alta qualità come immagini di prodotti e-commerce e fotografia di ritratti.',
        feature3Alt: 'Esempio di ottimizzazione dei dettagli di Dreamina 4.0',

        feature4Title: 'Generazione di Schizzi e Costruzione Fisica',
        feature4Desc:
            "Genera immagini fisiche di alta qualità basate su schizzi disegnati a mano, disegni al tratto o descrizioni testuali. Ad esempio, trasformare uno schizzo di una vecchia TV in un'immagine realistica o generare un modello di figura basato su uno schizzo di posa, accelerando la realizzazione creativa.",
        feature4Alt: 'Esempio di generazione di schizzi di Dreamina 4.0',

        feature5Title: 'Fusione Multi-Elemento e Composizione Narrativa',
        feature5Desc:
            'Supporta la sintesi di più personaggi o oggetti nella stessa scena con pose specificate per generare storyboard coerenti o gruppi di scene. Ad esempio, "generare una ragazza e una bambola mucca su una montagna russa in un parco divertimenti", migliorando le capacità di espressione narrativa.',
        feature5Alt: 'Esempio di fusione multi-elemento di Dreamina 4.0',

        // How to Use
        howToUseTitle: 'Come Usare',
        howToUseSubtitle: 'Tre semplici passaggi per iniziare a creare',

        step1Title: 'Seleziona Modello',
        step1Description:
            'Scegli il modello Dreamina negli strumenti immagini IA',

        step2Title: 'Inserisci Contenuto',
        step2Description: 'Inserisci prompt o carica immagini di riferimento',

        step3Title: 'Genera Immagine',
        step3Description:
            'Fai clic sul pulsante genera, attendi e scarica la tua immagine',

        // YouTube Section
        youtubeTitle: 'Video YouTube Sul Modello di Immagine Dreamina 4.0',

        // X Posts Section
        xPostsTitle: 'Post X Sul Modello di Immagine Dreamina 4.0',

        // Explore Models
        exploreModelsTitle: 'Esplora Altri Modelli di Immagini IA su 微鲤AI',
        model1Title: 'Generatore di Immagini IA Google Nano Banana',
        model2Title: 'Generatore di Immagini IA FLUX',
        model3Title: 'Generatore di Immagini IA Google Imagen',

        // FAQ
        faqTitle: 'Domande Frequenti',

        faq1Question: 'Per quali scenari è adatto Dreamina 4.0?',
        faq1Answer:
            "È adatto per l'ottimizzazione delle immagini di prodotti e-commerce, il trasferimento di stile artistico, la generazione di meme per l'intrattenimento sociale, il design pubblicitario, lo sviluppo di personaggi IP, ecc., eccellendo particolarmente nelle esigenze di design commerciale che richiedono un controllo ad alta precisione.",

        faq2Question:
            'Il modello può comprendere istruzioni di editing complesse e multistrato?',
        faq2Answer:
            'Supporta l\'analisi di istruzioni composte, come richiedere simultaneamente "cambiare prospettiva + regolare rapporto + stile di riferimento", il modello analizza elemento per elemento ed esegue in modo collaborativo per garantire che l\'output soddisfi le aspettative.',

        faq3Question:
            "Come sono la risoluzione e la qualità dell'immagine delle immagini generate?",
        faq3Answer:
            "Di default offre output ad alta definizione (risoluzione adattabile in base alle esigenze) e supporta opzioni di miglioramento dei dettagli per uso commerciale, come l'ottimizzazione della texture della pelle e la riparazione dell'illuminazione.",

        faq4Question: 'Supporta la generazione basata su schizzi o line art?',
        faq4Answer:
            'Sì, il modello accetta schizzi fatti a mano, diagrammi su lavagna (come formule matematiche) o line art come input, generando immagini complete combinate con istruzioni testuali.',

        faq5Question:
            'Come controllare la coerenza dello stile tra le immagini generate e le immagini di riferimento?',
        faq5Answer:
            "Attraverso istruzioni come \"contenuto dell'immagine di riferimento\", il modello estrae caratteristiche come tono, pennellata e materiale dall'immagine di riferimento per garantire un'alta coerenza di stile nell'output, come unificare i personaggi in texture di feltro.",

        faq6Question: 'Può generare gruppi di serie o design di blind box?',
        faq6Answer:
            "Supporta la generazione di più gruppi di varianti basati sullo stesso tema (come design di blind box di diverse figure animali) mantenendo uno stile unificato, adatto per l'estensione della linea di prodotti o la creazione di contenuti serializzati.",

        faq7Question:
            "Come bilancia il modello naturalezza e raffinatezza nell'elaborazione dei dettagli?",
        faq7Answer:
            "Nell'ottimizzare pelle, texture e illuminazione tramite algoritmi, vengono mantenuti dettagli ragionevoli (come pori, pieghe del tessuto) per evitare distorsioni da eccessiva abbellimento, garantendo visuali naturali e professionali.",

        faq8Question:
            'Ci sono soglie di utilizzo o requisiti di adattamento tecnico?',
        faq8Answer:
            "Fornisce interfacce di generazione end-to-end; gli utenti non necessitano di esperienza professionale nel design e possono generare rapidamente immagini tramite descrizioni in linguaggio naturale o schizzo+testo, supportando l'accesso API e l'integrazione della piattaforma.",

        // CTA Section
        ctaTitle: 'Inizia a Usare Dreamina 4.0 Ora',
        ctaDescription:
            'Sperimenta la tecnologia di generazione immagini IA di nuova generazione e crea opere visuali straordinarie',
        ctaButton: 'Prova Dreamina su 微鲤AI',
        ctaDisclaimer:
            'Nessuna carta di credito richiesta, inizia a creare ora',
    },
    ar: {
        // SEO Meta
        pageTitle: 'Dreamina 4.0 - نموذج توليد الصور بالذكاء الاصطناعي الرائد',
        pageDescription:
            'Dreamina 4.0 هو نموذج توليد الصور بالذكاء الاصطناعي من الجيل التالي الذي يوفر جودة سينمائية وتحرير مرن ومخرجات احترافية. يدعم النص إلى صورة والصورة إلى صورة. جربه مجانًا على 微鲤AI.',
        pageKeywords:
            'Dreamina 4.0, توليد الصور بالذكاء الاصطناعي, نص إلى صورة, صورة إلى صورة, فن الذكاء الاصطناعي, تحرير الصور, عرض سينمائي, 微鲤AI',
        ogTitle: 'مولد الصور بالذكاء الاصطناعي Dreamina 4.0 | 微鲤AI',
        ogDescription:
            'يوفر Dreamina 4.0 توليد صور بالذكاء الاصطناعي بجودة سينمائية مع أنماط متنوعة وقدرات تحرير احترافية',
        twitterTitle: 'Dreamina 4.0 - توليد صور احترافي بالذكاء الاصطناعي',
        twitterDescription:
            'جرب قوة Dreamina 4.0 لتوليد الصور بجودة سينمائية مع تحرير مرن',

        // Generator Section
        generatorTitle: 'مولد الصور بالذكاء الاصطناعي Dreamina 4.0',
        generatorSubtitle:
            'Dreamina 4.0 من ByteDance هو نموذج لتوليد وتحرير الصور بالذكاء الاصطناعي يعتمد على تقنية متعددة الوسائط متقدمة، يركز على توفير قدرات توليد محتوى مرئي عالي الدقة وعالي الحرية للتصميم التجاري والإبداع الفني والترفيه الاجتماعي. يدعم التعليمات المعقدة من إنشاء الرسومات ونقل النمط إلى تحسين التفاصيل ودمج الصور المتعددة، مما يحقق حقًا "الإبداع القائم على اللغة" لمساعدة المبدعين الأفراد والشركات على إنتاج محتوى مرئي احترافي بكفاءة.',

        // Core Features
        coreFeaturesTitle: 'الميزات الأساسية لـ Dreamina 4.0',
        coreFeaturesSubtitle:
            'استكشف القدرات القوية لـ Dreamina 4.0 وابدأ رحلتك في إنشاء الصور الاحترافية بالذكاء الاصطناعي',

        feature1Title: 'تحكم متعدد الأبعاد وإعادة بناء المنظور',
        feature1Desc:
            'يدعم تعديلات مرنة للمنظور (على سبيل المثال، مستوى العين إلى منظر علوي)، وحجم اللقطة (لقطة مقربة إلى لقطة متوسطة)، ونسبة العرض إلى الارتفاع (إطار مخصص). يستجيب بدقة للتعليمات المعقدة مثل "تغيير العرض بمستوى العين إلى عرض علوي، تغيير اللقطة المقربة إلى لقطة متوسطة"، مما يعزز التعبير البصري والقدرة على التكيف.',
        feature1Alt: 'مثال على التحكم متعدد الأبعاد لـ Dreamina 4.0',

        feature2Title: 'نقل النمط وتحويل المواد',
        feature2Desc:
            'يحقق معالجة منمقة مثل 3D إلى 2D، واقعي إلى رسم توضيحي/لباد بناءً على الصور المرجعية. يدعم استبدال المواد (على سبيل المثال، الزجاج، الجليد، الميكانيكي)، وتلبية الاحتياجات الإبداعية لتصميم الصناديق العمياء وتطوير مشتقات الملكية الفكرية.',
        feature2Alt: 'مثال على نقل النمط لـ Dreamina 4.0',

        feature3Title: 'تحسين التفاصيل والملمس التجاري',
        feature3Desc:
            'يحسن بشكل طبيعي جودة بشرة الوجه، وطيات الملابس، وتأثيرات الإضاءة. يحقق معالجة "مستوى التنقيح" مع الحفاظ على نسيج الجلد والتفاصيل، ومناسب لسيناريوهات الإخراج عالية الجودة مثل صور منتجات التجارة الإلكترونية وتصوير البورتريه.',
        feature3Alt: 'مثال على تحسين التفاصيل لـ Dreamina 4.0',

        feature4Title: 'إنشاء الرسومات والبناء المادي',
        feature4Desc:
            'يولد صورًا مادية عالية الجودة بناءً على الرسومات المرسومة باليد، أو فن الخط، أو الأوصاف النصية. على سبيل المثال، تحويل رسم لتلفزيون قديم إلى صورة واقعية، أو إنشاء نموذج شكل بناءً على رسم وضعي، وتسريع التحقيق الإبداعي.',
        feature4Alt: 'مثال على إنشاء الرسومات لـ Dreamina 4.0',

        feature5Title: 'دمج متعدد العناصر والتركيب القصصي',
        feature5Desc:
            'يدعم دمج شخصيات أو كائنات متعددة في نفس المشهد بوضعيات محددة لإنشاء قصص مصورة متماسكة أو مجموعات مشاهد. على سبيل المثال، "إنشاء فتاة ودمية بقرة تركبان أفعوانية في مدينة ملاهي"، مما يعزز قدرات التعبير السردي.',
        feature5Alt: 'مثال على دمج متعدد العناصر لـ Dreamina 4.0',

        // How to Use
        howToUseTitle: 'كيفية الاستخدام',
        howToUseSubtitle: 'ثلاث خطوات بسيطة للبدء في الإنشاء',

        step1Title: 'اختر النموذج',
        step1Description:
            'اختر نموذج Dreamina في أدوات الصور بالذكاء الاصطناعي',

        step2Title: 'أدخل المحتوى',
        step2Description: 'أدخل المطالبات أو قم بتحميل الصور المرجعية',

        step3Title: 'قم بإنشاء الصورة',
        step3Description: 'انقر فوق زر الإنشاء، انتظر وقم بتنزيل صورتك',

        // YouTube Section
        youtubeTitle: 'مقاطع فيديو YouTube حول نموذج الصورة Dreamina 4.0',

        // X Posts Section
        xPostsTitle: 'منشورات X حول نموذج الصورة Dreamina 4.0',

        // Explore Models
        exploreModelsTitle:
            'استكشف نماذج الصور الأخرى بالذكاء الاصطناعي على 微鲤AI',
        model1Title: 'مولد الصور بالذكاء الاصطناعي Google Nano Banana',
        model2Title: 'مولد الصور بالذكاء الاصطناعي FLUX',
        model3Title: 'مولد الصور بالذكاء الاصطناعي Google Imagen',

        // FAQ
        faqTitle: 'الأسئلة الشائعة',

        faq1Question: 'ما هي السيناريوهات المناسبة لـ Dreamina 4.0؟',
        faq1Answer:
            'مناسب لتحسين صور منتجات التجارة الإلكترونية، ونقل النمط الفني، وإنشاء الميمات الترفيهية الاجتماعية، وتصميم الإعلانات، وتطوير شخصيات الملكية الفكرية، وما إلى ذلك، ويتفوق بشكل خاص في احتياجات التصميم التجاري التي تتطلب تحكمًا عالي الدقة.',

        faq2Question:
            'هل يمكن للنموذج فهم تعليمات التحرير المعقدة متعددة الطبقات؟',
        faq2Answer:
            'يدعم تحليل التعليمات المركبة، مثل طلب "تغيير المنظور + ضبط النسبة + النمط المرجعي" في وقت واحد، ويقوم النموذج بتحليل عنصر تلو الآخر وينفذ بشكل تعاوني لضمان أن الناتج يلبي التوقعات.',

        faq3Question: 'كيف هي دقة وجودة الصورة للصور المُنشأة؟',
        faq3Answer:
            'افتراضيًا يوفر إخراجًا عالي الدقة (دقة قابلة للتكيف بناءً على الاحتياجات)، ويدعم خيارات تحسين التفاصيل للاستخدام التجاري، مثل تحسين نسيج الجلد وإصلاح الإضاءة.',

        faq4Question: 'هل يدعم التوليد بناءً على الرسومات أو فن الخط؟',
        faq4Answer:
            'نعم، يقبل النموذج الرسومات المرسومة باليد، أو الرسوم البيانية على السبورة البيضاء (مثل الصيغ الرياضية)، أو فن الخط كمدخلات، وينشئ صورًا كاملة مدمجة مع تعليمات نصية.',

        faq5Question:
            'كيف تتحكم في اتساق النمط بين الصور المُنشأة والصور المرجعية؟',
        faq5Answer:
            'من خلال تعليمات مثل "محتوى الصورة المرجعية"، يستخرج النموذج ميزات مثل النغمة وضربة الفرشاة والمواد من الصورة المرجعية لضمان اتساق النمط العالي في الناتج، مثل توحيد الشخصيات في نسيج اللباد.',

        faq6Question:
            'هل يمكنه إنشاء مجموعات متسلسلة أو تصميمات الصناديق العمياء؟',
        faq6Answer:
            'يدعم إنشاء مجموعات متغيرة متعددة بناءً على نفس الموضوع (مثل تصميمات الصناديق العمياء لشخصيات حيوانية مختلفة) مع الحفاظ على نمط موحد، ومناسب لتوسيع خط الإنتاج أو إنشاء محتوى متسلسل.',

        faq7Question:
            'كيف يوازن النموذج بين الطبيعية والتحسين في معالجة التفاصيل؟',
        faq7Answer:
            'عند تحسين الجلد والملمس والإضاءة عبر الخوارزميات، يتم الاحتفاظ بالتفاصيل المعقولة (مثل المسام وطيات القماش) لتجنب التشويه الناتج عن التجميل المفرط، مما يضمن صورًا طبيعية واحترافية.',

        faq8Question: 'هل هناك عتبات استخدام أو متطلبات تكيف تقني؟',
        faq8Answer:
            'يوفر واجهات توليد شاملة؛ لا يحتاج المستخدمون إلى خلفية تصميم احترافية ويمكنهم إنشاء صور بسرعة عبر أوصاف اللغة الطبيعية أو الرسم+النص، ودعم الوصول إلى API وتكامل المنصة.',

        // CTA Section
        ctaTitle: 'ابدأ استخدام Dreamina 4.0 الآن',
        ctaDescription:
            'جرب تقنية توليد الصور بالذكاء الاصطناعي من الجيل التالي وقم بإنشاء أعمال بصرية مذهلة',
        ctaButton: 'جرب Dreamina على 微鲤AI',
        ctaDisclaimer: 'لا حاجة لبطاقة ائتمان، ابدأ الإنشاء الآن',
    },
    th: {
        // Thai (copied from English)
        // SEO Meta
        pageTitle: 'Dreamina 4.0 - Leading AI Image Generation Model',
        pageDescription:
            'Dreamina 4.0 is a next-generation AI image generation model offering cinematic quality, flexible editing, and professional-grade output. Supports text-to-image and image-to-image. Try it free on 微鲤AI.',
        pageKeywords:
            'Dreamina 4.0, AI image generation, text to image, image to image, AI art, image editing, cinematic rendering, 微鲤AI',
        ogTitle: 'Dreamina 4.0 AI Image Generator | 微鲤AI',
        ogDescription:
            'Dreamina 4.0 delivers cinematic quality AI image generation with diverse styles and professional editing capabilities',
        twitterTitle: 'Dreamina 4.0 - Professional AI Image Generation',
        twitterDescription:
            'Experience the power of Dreamina 4.0 for cinematic quality image generation with flexible editing',

        // Generator Section
        generatorTitle: 'Dreamina 4.0 AI Image Generator',
        generatorSubtitle:
            'Dreamina 4.0 by ByteDance is an AI image generation and editing model based on advanced multimodal technology, focusing on providing high-precision, high-freedom visual content generation for commercial design, art creation, and social entertainment. It supports complex instructions from sketch generation and style transfer to detail optimization and multi-image fusion, truly realizing "language-driven creation" to help individual creators and enterprises efficiently produce professional-grade visual content.',

        // Core Features
        coreFeaturesTitle: 'Dreamina 4.0 Core Features',
        coreFeaturesSubtitle:
            'Explore the powerful capabilities of Dreamina 4.0 and start your professional AI image creation journey',

        feature1Title: 'Multidimensional Control & Perspective Reconstruction',
        feature1Desc:
            'Supports flexible adjustments of perspective (e.g., eye-level to overhead), shot size (close-up to medium shot), and aspect ratio. Accurately responds to complex instructions like "change eye-level to overhead view, change close-up to medium shot," enhancing visual expressiveness and adaptability.',
        feature1Alt: 'Dreamina 4.0 multidimensional control example',

        feature2Title: 'Style Transfer & Material Conversion',
        feature2Desc:
            'Achieves stylized processing like 3D to 2D, realistic to illustration/felt based on reference images. Supports material replacement (e.g., glass, ice, mechanical), meeting creative needs for blind box design and IP derivative development.',
        feature2Alt: 'Dreamina 4.0 style transfer example',

        feature3Title: 'Detail Optimization & Commercial-Grade Texture',
        feature3Desc:
            'Naturally optimizes facial skin quality, clothing folds, and lighting effects. Achieves "retouch-level" processing while retaining skin texture and details, suitable for high-quality output scenarios like e-commerce product images and portrait photography.',
        feature3Alt: 'Dreamina 4.0 detail optimization example',

        feature4Title: 'Sketch Generation & Physical Construction',
        feature4Desc:
            'Generates high-quality physical images based on hand-drawn sketches, line art, or text descriptions. For example, transforming a sketch of an old TV into a realistic image, or generating a figure model based on a pose sketch, accelerating creative realization.',
        feature4Alt: 'Dreamina 4.0 sketch generation example',

        feature5Title: 'Multi-Element Fusion & Storytelling Composition',
        feature5Desc:
            'Supports synthesizing multiple characters or objects into the same scene with specified poses to generate coherent storyboards or scene groups. For example, "generate a girl and a cow doll riding a roller coaster at an amusement park," enhancing narrative expression capabilities.',
        feature5Alt: 'Dreamina 4.0 multi-element fusion example',

        // How to Use
        howToUseTitle: 'How to Use',
        howToUseSubtitle: 'Three simple steps to start creating',

        step1Title: 'Select Model',
        step1Description: 'Choose Dreamina model in AI image tools',

        step2Title: 'Input Content',
        step2Description: 'Enter prompts or upload reference images',

        step3Title: 'Generate Image',
        step3Description: 'Click generate button, wait and download your image',

        // YouTube Section
        youtubeTitle: 'YouTube Videos About Dreamina 4.0 Image Model',

        // X Posts Section
        xPostsTitle: 'X Posts About Dreamina 4.0 Image Model',

        // Explore Models
        exploreModelsTitle: 'Explore Other AI Image Models on 微鲤AI',
        model1Title: 'Google Nano Banana AI Image Generator',
        model2Title: 'FLUX AI Image Generator',
        model3Title: 'Google Imagen AI Image Generator',

        // FAQ
        faqTitle: 'Frequently Asked Questions',

        faq1Question: 'What scenarios is Dreamina 4.0 suitable for?',
        faq1Answer:
            'Suitable for e-commerce product image optimization, artistic style transfer, social entertainment meme generation, ad design, IP character development, etc., especially excelling in commercial design needs requiring high-precision control.',

        faq2Question:
            'Can the model understand complex multi-layer editing instructions?',
        faq2Answer:
            'Supports compound instruction parsing, such as simultaneously requesting "change perspective + adjust ratio + reference style", the model parses item by item and executes collaboratively to ensure output meets expectations.',

        faq3Question:
            'How are the resolution and image quality of generated images?',
        faq3Answer:
            'Defaults to high-definition output (resolution adaptable based on needs), and supports detail enhancement options for commercial use, such as skin texture optimization and lighting repair.',

        faq4Question:
            'Does it support generation based on sketches or line art?',
        faq4Answer:
            'Yes, the model accepts hand-drawn sketches, whiteboard diagrams (like math formulas), or line art as input, generating complete images combined with text instructions.',

        faq5Question:
            'How to control style consistency between generated images and reference images?',
        faq5Answer:
            'Through instructions like "reference image content", the model extracts features like tone, brushwork, and material from the reference image to ensure highly consistent output style, such as unifying characters into felt texture.',

        faq6Question: 'Can it generate series groups or blind box designs?',
        faq6Answer:
            'Supports generating multiple variant groups based on the same theme (like blind box designs of different animal figures) while maintaining unified style, suitable for product line extension or serialized content creation.',

        faq7Question:
            'How does the model balance naturalness and refinement in detail processing?',
        faq7Answer:
            'When optimizing skin, texture, and lighting via algorithms, reasonable details (like pores, fabric folds) are retained to avoid distortion from over-beautification, ensuring natural and professional visuals.',

        faq8Question:
            'Are there any usage thresholds or technical adaptation requirements?',
        faq8Answer:
            'Provides end-to-end generation interfaces; users need no professional design background and can quickly generate images via natural language descriptions or sketch+text, supporting API access and platform integration.',

        // CTA Section
        ctaTitle: 'Start Using Dreamina 4.0 Now',
        ctaDescription:
            'Experience next-generation AI image generation technology and create stunning visual works',
        ctaButton: 'Try Dreamina on 微鲤AI',
        ctaDisclaimer: 'No credit card required, start creating now',
    },
    da: {
        // Danish (copied from English)
        // SEO Meta
        pageTitle: 'Dreamina 4.0 - Leading AI Image Generation Model',
        pageDescription:
            'Dreamina 4.0 is a next-generation AI image generation model offering cinematic quality, flexible editing, and professional-grade output. Supports text-to-image and image-to-image. Try it free on 微鲤AI.',
        pageKeywords:
            'Dreamina 4.0, AI image generation, text to image, image to image, AI art, image editing, cinematic rendering, 微鲤AI',
        ogTitle: 'Dreamina 4.0 AI Image Generator | 微鲤AI',
        ogDescription:
            'Dreamina 4.0 delivers cinematic quality AI image generation with diverse styles and professional editing capabilities',
        twitterTitle: 'Dreamina 4.0 - Professional AI Image Generation',
        twitterDescription:
            'Experience the power of Dreamina 4.0 for cinematic quality image generation with flexible editing',

        // Generator Section
        generatorTitle: 'Dreamina 4.0 AI Image Generator',
        generatorSubtitle:
            'Dreamina 4.0 by ByteDance is an AI image generation and editing model based on advanced multimodal technology, focusing on providing high-precision, high-freedom visual content generation for commercial design, art creation, and social entertainment. It supports complex instructions from sketch generation and style transfer to detail optimization and multi-image fusion, truly realizing "language-driven creation" to help individual creators and enterprises efficiently produce professional-grade visual content.',

        // Core Features
        coreFeaturesTitle: 'Dreamina 4.0 Core Features',
        coreFeaturesSubtitle:
            'Explore the powerful capabilities of Dreamina 4.0 and start your professional AI image creation journey',

        feature1Title: 'Multidimensional Control & Perspective Reconstruction',
        feature1Desc:
            'Supports flexible adjustments of perspective (e.g., eye-level to overhead), shot size (close-up to medium shot), and aspect ratio. Accurately responds to complex instructions like "change eye-level to overhead view, change close-up to medium shot," enhancing visual expressiveness and adaptability.',
        feature1Alt: 'Dreamina 4.0 multidimensional control example',

        feature2Title: 'Style Transfer & Material Conversion',
        feature2Desc:
            'Achieves stylized processing like 3D to 2D, realistic to illustration/felt based on reference images. Supports material replacement (e.g., glass, ice, mechanical), meeting creative needs for blind box design and IP derivative development.',
        feature2Alt: 'Dreamina 4.0 style transfer example',

        feature3Title: 'Detail Optimization & Commercial-Grade Texture',
        feature3Desc:
            'Naturally optimizes facial skin quality, clothing folds, and lighting effects. Achieves "retouch-level" processing while retaining skin texture and details, suitable for high-quality output scenarios like e-commerce product images and portrait photography.',
        feature3Alt: 'Dreamina 4.0 detail optimization example',

        feature4Title: 'Sketch Generation & Physical Construction',
        feature4Desc:
            'Generates high-quality physical images based on hand-drawn sketches, line art, or text descriptions. For example, transforming a sketch of an old TV into a realistic image, or generating a figure model based on a pose sketch, accelerating creative realization.',
        feature4Alt: 'Dreamina 4.0 sketch generation example',

        feature5Title: 'Multi-Element Fusion & Storytelling Composition',
        feature5Desc:
            'Supports synthesizing multiple characters or objects into the same scene with specified poses to generate coherent storyboards or scene groups. For example, "generate a girl and a cow doll riding a roller coaster at an amusement park," enhancing narrative expression capabilities.',
        feature5Alt: 'Dreamina 4.0 multi-element fusion example',

        // How to Use
        howToUseTitle: 'How to Use',
        howToUseSubtitle: 'Three simple steps to start creating',

        step1Title: 'Select Model',
        step1Description: 'Choose Dreamina model in AI image tools',

        step2Title: 'Input Content',
        step2Description: 'Enter prompts or upload reference images',

        step3Title: 'Generate Image',
        step3Description: 'Click generate button, wait and download your image',

        // YouTube Section
        youtubeTitle: 'YouTube Videos About Dreamina 4.0 Image Model',

        // X Posts Section
        xPostsTitle: 'X Posts About Dreamina 4.0 Image Model',

        // Explore Models
        exploreModelsTitle: 'Explore Other AI Image Models on 微鲤AI',
        model1Title: 'Google Nano Banana AI Image Generator',
        model2Title: 'FLUX AI Image Generator',
        model3Title: 'Google Imagen AI Image Generator',

        // FAQ
        faqTitle: 'Frequently Asked Questions',

        faq1Question: 'What scenarios is Dreamina 4.0 suitable for?',
        faq1Answer:
            'Suitable for e-commerce product image optimization, artistic style transfer, social entertainment meme generation, ad design, IP character development, etc., especially excelling in commercial design needs requiring high-precision control.',

        faq2Question:
            'Can the model understand complex multi-layer editing instructions?',
        faq2Answer:
            'Supports compound instruction parsing, such as simultaneously requesting "change perspective + adjust ratio + reference style", the model parses item by item and executes collaboratively to ensure output meets expectations.',

        faq3Question:
            'How are the resolution and image quality of generated images?',
        faq3Answer:
            'Defaults to high-definition output (resolution adaptable based on needs), and supports detail enhancement options for commercial use, such as skin texture optimization and lighting repair.',

        faq4Question:
            'Does it support generation based on sketches or line art?',
        faq4Answer:
            'Yes, the model accepts hand-drawn sketches, whiteboard diagrams (like math formulas), or line art as input, generating complete images combined with text instructions.',

        faq5Question:
            'How to control style consistency between generated images and reference images?',
        faq5Answer:
            'Through instructions like "reference image content", the model extracts features like tone, brushwork, and material from the reference image to ensure highly consistent output style, such as unifying characters into felt texture.',

        faq6Question: 'Can it generate series groups or blind box designs?',
        faq6Answer:
            'Supports generating multiple variant groups based on the same theme (like blind box designs of different animal figures) while maintaining unified style, suitable for product line extension or serialized content creation.',

        faq7Question:
            'How does the model balance naturalness and refinement in detail processing?',
        faq7Answer:
            'When optimizing skin, texture, and lighting via algorithms, reasonable details (like pores, fabric folds) are retained to avoid distortion from over-beautification, ensuring natural and professional visuals.',

        faq8Question:
            'Are there any usage thresholds or technical adaptation requirements?',
        faq8Answer:
            'Provides end-to-end generation interfaces; users need no professional design background and can quickly generate images via natural language descriptions or sketch+text, supporting API access and platform integration.',

        // CTA Section
        ctaTitle: 'Start Using Dreamina 4.0 Now',
        ctaDescription:
            'Experience next-generation AI image generation technology and create stunning visual works',
        ctaButton: 'Try Dreamina on 微鲤AI',
        ctaDisclaimer: 'No credit card required, start creating now',
    },
    no: {
        // Norwegian (copied from English)
        // SEO Meta
        pageTitle: 'Dreamina 4.0 - Leading AI Image Generation Model',
        pageDescription:
            'Dreamina 4.0 is a next-generation AI image generation model offering cinematic quality, flexible editing, and professional-grade output. Supports text-to-image and image-to-image. Try it free on 微鲤AI.',
        pageKeywords:
            'Dreamina 4.0, AI image generation, text to image, image to image, AI art, image editing, cinematic rendering, 微鲤AI',
        ogTitle: 'Dreamina 4.0 AI Image Generator | 微鲤AI',
        ogDescription:
            'Dreamina 4.0 delivers cinematic quality AI image generation with diverse styles and professional editing capabilities',
        twitterTitle: 'Dreamina 4.0 - Professional AI Image Generation',
        twitterDescription:
            'Experience the power of Dreamina 4.0 for cinematic quality image generation with flexible editing',

        // Generator Section
        generatorTitle: 'Dreamina 4.0 AI Image Generator',
        generatorSubtitle:
            'Dreamina 4.0 by ByteDance is an AI image generation and editing model based on advanced multimodal technology, focusing on providing high-precision, high-freedom visual content generation for commercial design, art creation, and social entertainment. It supports complex instructions from sketch generation and style transfer to detail optimization and multi-image fusion, truly realizing "language-driven creation" to help individual creators and enterprises efficiently produce professional-grade visual content.',

        // Core Features
        coreFeaturesTitle: 'Dreamina 4.0 Core Features',
        coreFeaturesSubtitle:
            'Explore the powerful capabilities of Dreamina 4.0 and start your professional AI image creation journey',

        feature1Title: 'Multidimensional Control & Perspective Reconstruction',
        feature1Desc:
            'Supports flexible adjustments of perspective (e.g., eye-level to overhead), shot size (close-up to medium shot), and aspect ratio. Accurately responds to complex instructions like "change eye-level to overhead view, change close-up to medium shot," enhancing visual expressiveness and adaptability.',
        feature1Alt: 'Dreamina 4.0 multidimensional control example',

        feature2Title: 'Style Transfer & Material Conversion',
        feature2Desc:
            'Achieves stylized processing like 3D to 2D, realistic to illustration/felt based on reference images. Supports material replacement (e.g., glass, ice, mechanical), meeting creative needs for blind box design and IP derivative development.',
        feature2Alt: 'Dreamina 4.0 style transfer example',

        feature3Title: 'Detail Optimization & Commercial-Grade Texture',
        feature3Desc:
            'Naturally optimizes facial skin quality, clothing folds, and lighting effects. Achieves "retouch-level" processing while retaining skin texture and details, suitable for high-quality output scenarios like e-commerce product images and portrait photography.',
        feature3Alt: 'Dreamina 4.0 detail optimization example',

        feature4Title: 'Sketch Generation & Physical Construction',
        feature4Desc:
            'Generates high-quality physical images based on hand-drawn sketches, line art, or text descriptions. For example, transforming a sketch of an old TV into a realistic image, or generating a figure model based on a pose sketch, accelerating creative realization.',
        feature4Alt: 'Dreamina 4.0 sketch generation example',

        feature5Title: 'Multi-Element Fusion & Storytelling Composition',
        feature5Desc:
            'Supports synthesizing multiple characters or objects into the same scene with specified poses to generate coherent storyboards or scene groups. For example, "generate a girl and a cow doll riding a roller coaster at an amusement park," enhancing narrative expression capabilities.',
        feature5Alt: 'Dreamina 4.0 multi-element fusion example',

        // How to Use
        howToUseTitle: 'How to Use',
        howToUseSubtitle: 'Three simple steps to start creating',

        step1Title: 'Select Model',
        step1Description: 'Choose Dreamina model in AI image tools',

        step2Title: 'Input Content',
        step2Description: 'Enter prompts or upload reference images',

        step3Title: 'Generate Image',
        step3Description: 'Click generate button, wait and download your image',

        // YouTube Section
        youtubeTitle: 'YouTube Videos About Dreamina 4.0 Image Model',

        // X Posts Section
        xPostsTitle: 'X Posts About Dreamina 4.0 Image Model',

        // Explore Models
        exploreModelsTitle: 'Explore Other AI Image Models on 微鲤AI',
        model1Title: 'Google Nano Banana AI Image Generator',
        model2Title: 'FLUX AI Image Generator',
        model3Title: 'Google Imagen AI Image Generator',

        // FAQ
        faqTitle: 'Frequently Asked Questions',

        faq1Question: 'What scenarios is Dreamina 4.0 suitable for?',
        faq1Answer:
            'Suitable for e-commerce product image optimization, artistic style transfer, social entertainment meme generation, ad design, IP character development, etc., especially excelling in commercial design needs requiring high-precision control.',

        faq2Question:
            'Can the model understand complex multi-layer editing instructions?',
        faq2Answer:
            'Supports compound instruction parsing, such as simultaneously requesting "change perspective + adjust ratio + reference style", the model parses item by item and executes collaboratively to ensure output meets expectations.',

        faq3Question:
            'How are the resolution and image quality of generated images?',
        faq3Answer:
            'Defaults to high-definition output (resolution adaptable based on needs), and supports detail enhancement options for commercial use, such as skin texture optimization and lighting repair.',

        faq4Question:
            'Does it support generation based on sketches or line art?',
        faq4Answer:
            'Yes, the model accepts hand-drawn sketches, whiteboard diagrams (like math formulas), or line art as input, generating complete images combined with text instructions.',

        faq5Question:
            'How to control style consistency between generated images and reference images?',
        faq5Answer:
            'Through instructions like "reference image content", the model extracts features like tone, brushwork, and material from the reference image to ensure highly consistent output style, such as unifying characters into felt texture.',

        faq6Question: 'Can it generate series groups or blind box designs?',
        faq6Answer:
            'Supports generating multiple variant groups based on the same theme (like blind box designs of different animal figures) while maintaining unified style, suitable for product line extension or serialized content creation.',

        faq7Question:
            'How does the model balance naturalness and refinement in detail processing?',
        faq7Answer:
            'When optimizing skin, texture, and lighting via algorithms, reasonable details (like pores, fabric folds) are retained to avoid distortion from over-beautification, ensuring natural and professional visuals.',

        faq8Question:
            'Are there any usage thresholds or technical adaptation requirements?',
        faq8Answer:
            'Provides end-to-end generation interfaces; users need no professional design background and can quickly generate images via natural language descriptions or sketch+text, supporting API access and platform integration.',

        // CTA Section
        ctaTitle: 'Start Using Dreamina 4.0 Now',
        ctaDescription:
            'Experience next-generation AI image generation technology and create stunning visual works',
        ctaButton: 'Try Dreamina on 微鲤AI',
        ctaDisclaimer: 'No credit card required, start creating now',
    },
    nl: {
        // Dutch (copied from English)
        // SEO Meta
        pageTitle: 'Dreamina 4.0 - Leading AI Image Generation Model',
        pageDescription:
            'Dreamina 4.0 is a next-generation AI image generation model offering cinematic quality, flexible editing, and professional-grade output. Supports text-to-image and image-to-image. Try it free on 微鲤AI.',
        pageKeywords:
            'Dreamina 4.0, AI image generation, text to image, image to image, AI art, image editing, cinematic rendering, 微鲤AI',
        ogTitle: 'Dreamina 4.0 AI Image Generator | 微鲤AI',
        ogDescription:
            'Dreamina 4.0 delivers cinematic quality AI image generation with diverse styles and professional editing capabilities',
        twitterTitle: 'Dreamina 4.0 - Professional AI Image Generation',
        twitterDescription:
            'Experience the power of Dreamina 4.0 for cinematic quality image generation with flexible editing',

        // Generator Section
        generatorTitle: 'Dreamina 4.0 AI Image Generator',
        generatorSubtitle:
            'Dreamina 4.0 by ByteDance is an AI image generation and editing model based on advanced multimodal technology, focusing on providing high-precision, high-freedom visual content generation for commercial design, art creation, and social entertainment. It supports complex instructions from sketch generation and style transfer to detail optimization and multi-image fusion, truly realizing "language-driven creation" to help individual creators and enterprises efficiently produce professional-grade visual content.',

        // Core Features
        coreFeaturesTitle: 'Dreamina 4.0 Core Features',
        coreFeaturesSubtitle:
            'Explore the powerful capabilities of Dreamina 4.0 and start your professional AI image creation journey',

        feature1Title: 'Multidimensional Control & Perspective Reconstruction',
        feature1Desc:
            'Supports flexible adjustments of perspective (e.g., eye-level to overhead), shot size (close-up to medium shot), and aspect ratio. Accurately responds to complex instructions like "change eye-level to overhead view, change close-up to medium shot," enhancing visual expressiveness and adaptability.',
        feature1Alt: 'Dreamina 4.0 multidimensional control example',

        feature2Title: 'Style Transfer & Material Conversion',
        feature2Desc:
            'Achieves stylized processing like 3D to 2D, realistic to illustration/felt based on reference images. Supports material replacement (e.g., glass, ice, mechanical), meeting creative needs for blind box design and IP derivative development.',
        feature2Alt: 'Dreamina 4.0 style transfer example',

        feature3Title: 'Detail Optimization & Commercial-Grade Texture',
        feature3Desc:
            'Naturally optimizes facial skin quality, clothing folds, and lighting effects. Achieves "retouch-level" processing while retaining skin texture and details, suitable for high-quality output scenarios like e-commerce product images and portrait photography.',
        feature3Alt: 'Dreamina 4.0 detail optimization example',

        feature4Title: 'Sketch Generation & Physical Construction',
        feature4Desc:
            'Generates high-quality physical images based on hand-drawn sketches, line art, or text descriptions. For example, transforming a sketch of an old TV into a realistic image, or generating a figure model based on a pose sketch, accelerating creative realization.',
        feature4Alt: 'Dreamina 4.0 sketch generation example',

        feature5Title: 'Multi-Element Fusion & Storytelling Composition',
        feature5Desc:
            'Supports synthesizing multiple characters or objects into the same scene with specified poses to generate coherent storyboards or scene groups. For example, "generate a girl and a cow doll riding a roller coaster at an amusement park," enhancing narrative expression capabilities.',
        feature5Alt: 'Dreamina 4.0 multi-element fusion example',

        // How to Use
        howToUseTitle: 'How to Use',
        howToUseSubtitle: 'Three simple steps to start creating',

        step1Title: 'Select Model',
        step1Description: 'Choose Dreamina model in AI image tools',

        step2Title: 'Input Content',
        step2Description: 'Enter prompts or upload reference images',

        step3Title: 'Generate Image',
        step3Description: 'Click generate button, wait and download your image',

        // YouTube Section
        youtubeTitle: 'YouTube Videos About Dreamina 4.0 Image Model',

        // X Posts Section
        xPostsTitle: 'X Posts About Dreamina 4.0 Image Model',

        // Explore Models
        exploreModelsTitle: 'Explore Other AI Image Models on 微鲤AI',
        model1Title: 'Google Nano Banana AI Image Generator',
        model2Title: 'FLUX AI Image Generator',
        model3Title: 'Google Imagen AI Image Generator',

        // FAQ
        faqTitle: 'Frequently Asked Questions',

        faq1Question: 'What scenarios is Dreamina 4.0 suitable for?',
        faq1Answer:
            'Suitable for e-commerce product image optimization, artistic style transfer, social entertainment meme generation, ad design, IP character development, etc., especially excelling in commercial design needs requiring high-precision control.',

        faq2Question:
            'Can the model understand complex multi-layer editing instructions?',
        faq2Answer:
            'Supports compound instruction parsing, such as simultaneously requesting "change perspective + adjust ratio + reference style", the model parses item by item and executes collaboratively to ensure output meets expectations.',

        faq3Question:
            'How are the resolution and image quality of generated images?',
        faq3Answer:
            'Defaults to high-definition output (resolution adaptable based on needs), and supports detail enhancement options for commercial use, such as skin texture optimization and lighting repair.',

        faq4Question:
            'Does it support generation based on sketches or line art?',
        faq4Answer:
            'Yes, the model accepts hand-drawn sketches, whiteboard diagrams (like math formulas), or line art as input, generating complete images combined with text instructions.',

        faq5Question:
            'How to control style consistency between generated images and reference images?',
        faq5Answer:
            'Through instructions like "reference image content", the model extracts features like tone, brushwork, and material from the reference image to ensure highly consistent output style, such as unifying characters into felt texture.',

        faq6Question: 'Can it generate series groups or blind box designs?',
        faq6Answer:
            'Supports generating multiple variant groups based on the same theme (like blind box designs of different animal figures) while maintaining unified style, suitable for product line extension or serialized content creation.',

        faq7Question:
            'How does the model balance naturalness and refinement in detail processing?',
        faq7Answer:
            'When optimizing skin, texture, and lighting via algorithms, reasonable details (like pores, fabric folds) are retained to avoid distortion from over-beautification, ensuring natural and professional visuals.',

        faq8Question:
            'Are there any usage thresholds or technical adaptation requirements?',
        faq8Answer:
            'Provides end-to-end generation interfaces; users need no professional design background and can quickly generate images via natural language descriptions or sketch+text, supporting API access and platform integration.',

        // CTA Section
        ctaTitle: 'Start Using Dreamina 4.0 Now',
        ctaDescription:
            'Experience next-generation AI image generation technology and create stunning visual works',
        ctaButton: 'Try Dreamina on 微鲤AI',
        ctaDisclaimer: 'No credit card required, start creating now',
    },
    id: {
        // Indonesian (copied from English)
        // SEO Meta
        pageTitle: 'Dreamina 4.0 - Leading AI Image Generation Model',
        pageDescription:
            'Dreamina 4.0 is a next-generation AI image generation model offering cinematic quality, flexible editing, and professional-grade output. Supports text-to-image and image-to-image. Try it free on 微鲤AI.',
        pageKeywords:
            'Dreamina 4.0, AI image generation, text to image, image to image, AI art, image editing, cinematic rendering, 微鲤AI',
        ogTitle: 'Dreamina 4.0 AI Image Generator | 微鲤AI',
        ogDescription:
            'Dreamina 4.0 delivers cinematic quality AI image generation with diverse styles and professional editing capabilities',
        twitterTitle: 'Dreamina 4.0 - Professional AI Image Generation',
        twitterDescription:
            'Experience the power of Dreamina 4.0 for cinematic quality image generation with flexible editing',

        // Generator Section
        generatorTitle: 'Dreamina 4.0 AI Image Generator',
        generatorSubtitle:
            'Dreamina 4.0 by ByteDance is an AI image generation and editing model based on advanced multimodal technology, focusing on providing high-precision, high-freedom visual content generation for commercial design, art creation, and social entertainment. It supports complex instructions from sketch generation and style transfer to detail optimization and multi-image fusion, truly realizing "language-driven creation" to help individual creators and enterprises efficiently produce professional-grade visual content.',

        // Core Features
        coreFeaturesTitle: 'Dreamina 4.0 Core Features',
        coreFeaturesSubtitle:
            'Explore the powerful capabilities of Dreamina 4.0 and start your professional AI image creation journey',

        feature1Title: 'Multidimensional Control & Perspective Reconstruction',
        feature1Desc:
            'Supports flexible adjustments of perspective (e.g., eye-level to overhead), shot size (close-up to medium shot), and aspect ratio. Accurately responds to complex instructions like "change eye-level to overhead view, change close-up to medium shot," enhancing visual expressiveness and adaptability.',
        feature1Alt: 'Dreamina 4.0 multidimensional control example',

        feature2Title: 'Style Transfer & Material Conversion',
        feature2Desc:
            'Achieves stylized processing like 3D to 2D, realistic to illustration/felt based on reference images. Supports material replacement (e.g., glass, ice, mechanical), meeting creative needs for blind box design and IP derivative development.',
        feature2Alt: 'Dreamina 4.0 style transfer example',

        feature3Title: 'Detail Optimization & Commercial-Grade Texture',
        feature3Desc:
            'Naturally optimizes facial skin quality, clothing folds, and lighting effects. Achieves "retouch-level" processing while retaining skin texture and details, suitable for high-quality output scenarios like e-commerce product images and portrait photography.',
        feature3Alt: 'Dreamina 4.0 detail optimization example',

        feature4Title: 'Sketch Generation & Physical Construction',
        feature4Desc:
            'Generates high-quality physical images based on hand-drawn sketches, line art, or text descriptions. For example, transforming a sketch of an old TV into a realistic image, or generating a figure model based on a pose sketch, accelerating creative realization.',
        feature4Alt: 'Dreamina 4.0 sketch generation example',

        feature5Title: 'Multi-Element Fusion & Storytelling Composition',
        feature5Desc:
            'Supports synthesizing multiple characters or objects into the same scene with specified poses to generate coherent storyboards or scene groups. For example, "generate a girl and a cow doll riding a roller coaster at an amusement park," enhancing narrative expression capabilities.',
        feature5Alt: 'Dreamina 4.0 multi-element fusion example',

        // How to Use
        howToUseTitle: 'How to Use',
        howToUseSubtitle: 'Three simple steps to start creating',

        step1Title: 'Select Model',
        step1Description: 'Choose Dreamina model in AI image tools',

        step2Title: 'Input Content',
        step2Description: 'Enter prompts or upload reference images',

        step3Title: 'Generate Image',
        step3Description: 'Click generate button, wait and download your image',

        // YouTube Section
        youtubeTitle: 'YouTube Videos About Dreamina 4.0 Image Model',

        // X Posts Section
        xPostsTitle: 'X Posts About Dreamina 4.0 Image Model',

        // Explore Models
        exploreModelsTitle: 'Explore Other AI Image Models on 微鲤AI',
        model1Title: 'Google Nano Banana AI Image Generator',
        model2Title: 'FLUX AI Image Generator',
        model3Title: 'Google Imagen AI Image Generator',

        // FAQ
        faqTitle: 'Frequently Asked Questions',

        faq1Question: 'What scenarios is Dreamina 4.0 suitable for?',
        faq1Answer:
            'Suitable for e-commerce product image optimization, artistic style transfer, social entertainment meme generation, ad design, IP character development, etc., especially excelling in commercial design needs requiring high-precision control.',

        faq2Question:
            'Can the model understand complex multi-layer editing instructions?',
        faq2Answer:
            'Supports compound instruction parsing, such as simultaneously requesting "change perspective + adjust ratio + reference style", the model parses item by item and executes collaboratively to ensure output meets expectations.',

        faq3Question:
            'How are the resolution and image quality of generated images?',
        faq3Answer:
            'Defaults to high-definition output (resolution adaptable based on needs), and supports detail enhancement options for commercial use, such as skin texture optimization and lighting repair.',

        faq4Question:
            'Does it support generation based on sketches or line art?',
        faq4Answer:
            'Yes, the model accepts hand-drawn sketches, whiteboard diagrams (like math formulas), or line art as input, generating complete images combined with text instructions.',

        faq5Question:
            'How to control style consistency between generated images and reference images?',
        faq5Answer:
            'Through instructions like "reference image content", the model extracts features like tone, brushwork, and material from the reference image to ensure highly consistent output style, such as unifying characters into felt texture.',

        faq6Question: 'Can it generate series groups or blind box designs?',
        faq6Answer:
            'Supports generating multiple variant groups based on the same theme (like blind box designs of different animal figures) while maintaining unified style, suitable for product line extension or serialized content creation.',

        faq7Question:
            'How does the model balance naturalness and refinement in detail processing?',
        faq7Answer:
            'When optimizing skin, texture, and lighting via algorithms, reasonable details (like pores, fabric folds) are retained to avoid distortion from over-beautification, ensuring natural and professional visuals.',

        faq8Question:
            'Are there any usage thresholds or technical adaptation requirements?',
        faq8Answer:
            'Provides end-to-end generation interfaces; users need no professional design background and can quickly generate images via natural language descriptions or sketch+text, supporting API access and platform integration.',

        // CTA Section
        ctaTitle: 'Start Using Dreamina 4.0 Now',
        ctaDescription:
            'Experience next-generation AI image generation technology and create stunning visual works',
        ctaButton: 'Try Dreamina on 微鲤AI',
        ctaDisclaimer: 'No credit card required, start creating now',
    },
    tr: {
        // Turkish (copied from English)
        // SEO Meta
        pageTitle: 'Dreamina 4.0 - Leading AI Image Generation Model',
        pageDescription:
            'Dreamina 4.0 is a next-generation AI image generation model offering cinematic quality, flexible editing, and professional-grade output. Supports text-to-image and image-to-image. Try it free on 微鲤AI.',
        pageKeywords:
            'Dreamina 4.0, AI image generation, text to image, image to image, AI art, image editing, cinematic rendering, 微鲤AI',
        ogTitle: 'Dreamina 4.0 AI Image Generator | 微鲤AI',
        ogDescription:
            'Dreamina 4.0 delivers cinematic quality AI image generation with diverse styles and professional editing capabilities',
        twitterTitle: 'Dreamina 4.0 - Professional AI Image Generation',
        twitterDescription:
            'Experience the power of Dreamina 4.0 for cinematic quality image generation with flexible editing',

        // Generator Section
        generatorTitle: 'Dreamina 4.0 AI Image Generator',
        generatorSubtitle:
            'Dreamina 4.0 by ByteDance is an AI image generation and editing model based on advanced multimodal technology, focusing on providing high-precision, high-freedom visual content generation for commercial design, art creation, and social entertainment. It supports complex instructions from sketch generation and style transfer to detail optimization and multi-image fusion, truly realizing "language-driven creation" to help individual creators and enterprises efficiently produce professional-grade visual content.',

        // Core Features
        coreFeaturesTitle: 'Dreamina 4.0 Core Features',
        coreFeaturesSubtitle:
            'Explore the powerful capabilities of Dreamina 4.0 and start your professional AI image creation journey',

        feature1Title: 'Multidimensional Control & Perspective Reconstruction',
        feature1Desc:
            'Supports flexible adjustments of perspective (e.g., eye-level to overhead), shot size (close-up to medium shot), and aspect ratio. Accurately responds to complex instructions like "change eye-level to overhead view, change close-up to medium shot," enhancing visual expressiveness and adaptability.',
        feature1Alt: 'Dreamina 4.0 multidimensional control example',

        feature2Title: 'Style Transfer & Material Conversion',
        feature2Desc:
            'Achieves stylized processing like 3D to 2D, realistic to illustration/felt based on reference images. Supports material replacement (e.g., glass, ice, mechanical), meeting creative needs for blind box design and IP derivative development.',
        feature2Alt: 'Dreamina 4.0 style transfer example',

        feature3Title: 'Detail Optimization & Commercial-Grade Texture',
        feature3Desc:
            'Naturally optimizes facial skin quality, clothing folds, and lighting effects. Achieves "retouch-level" processing while retaining skin texture and details, suitable for high-quality output scenarios like e-commerce product images and portrait photography.',
        feature3Alt: 'Dreamina 4.0 detail optimization example',

        feature4Title: 'Sketch Generation & Physical Construction',
        feature4Desc:
            'Generates high-quality physical images based on hand-drawn sketches, line art, or text descriptions. For example, transforming a sketch of an old TV into a realistic image, or generating a figure model based on a pose sketch, accelerating creative realization.',
        feature4Alt: 'Dreamina 4.0 sketch generation example',

        feature5Title: 'Multi-Element Fusion & Storytelling Composition',
        feature5Desc:
            'Supports synthesizing multiple characters or objects into the same scene with specified poses to generate coherent storyboards or scene groups. For example, "generate a girl and a cow doll riding a roller coaster at an amusement park," enhancing narrative expression capabilities.',
        feature5Alt: 'Dreamina 4.0 multi-element fusion example',

        // How to Use
        howToUseTitle: 'How to Use',
        howToUseSubtitle: 'Three simple steps to start creating',

        step1Title: 'Select Model',
        step1Description: 'Choose Dreamina model in AI image tools',

        step2Title: 'Input Content',
        step2Description: 'Enter prompts or upload reference images',

        step3Title: 'Generate Image',
        step3Description: 'Click generate button, wait and download your image',

        // YouTube Section
        youtubeTitle: 'YouTube Videos About Dreamina 4.0 Image Model',

        // X Posts Section
        xPostsTitle: 'X Posts About Dreamina 4.0 Image Model',

        // Explore Models
        exploreModelsTitle: 'Explore Other AI Image Models on 微鲤AI',
        model1Title: 'Google Nano Banana AI Image Generator',
        model2Title: 'FLUX AI Image Generator',
        model3Title: 'Google Imagen AI Image Generator',

        // FAQ
        faqTitle: 'Frequently Asked Questions',

        faq1Question: 'What scenarios is Dreamina 4.0 suitable for?',
        faq1Answer:
            'Suitable for e-commerce product image optimization, artistic style transfer, social entertainment meme generation, ad design, IP character development, etc., especially excelling in commercial design needs requiring high-precision control.',

        faq2Question:
            'Can the model understand complex multi-layer editing instructions?',
        faq2Answer:
            'Supports compound instruction parsing, such as simultaneously requesting "change perspective + adjust ratio + reference style", the model parses item by item and executes collaboratively to ensure output meets expectations.',

        faq3Question:
            'How are the resolution and image quality of generated images?',
        faq3Answer:
            'Defaults to high-definition output (resolution adaptable based on needs), and supports detail enhancement options for commercial use, such as skin texture optimization and lighting repair.',

        faq4Question:
            'Does it support generation based on sketches or line art?',
        faq4Answer:
            'Yes, the model accepts hand-drawn sketches, whiteboard diagrams (like math formulas), or line art as input, generating complete images combined with text instructions.',

        faq5Question:
            'How to control style consistency between generated images and reference images?',
        faq5Answer:
            'Through instructions like "reference image content", the model extracts features like tone, brushwork, and material from the reference image to ensure highly consistent output style, such as unifying characters into felt texture.',

        faq6Question: 'Can it generate series groups or blind box designs?',
        faq6Answer:
            'Supports generating multiple variant groups based on the same theme (like blind box designs of different animal figures) while maintaining unified style, suitable for product line extension or serialized content creation.',

        faq7Question:
            'How does the model balance naturalness and refinement in detail processing?',
        faq7Answer:
            'When optimizing skin, texture, and lighting via algorithms, reasonable details (like pores, fabric folds) are retained to avoid distortion from over-beautification, ensuring natural and professional visuals.',

        faq8Question:
            'Are there any usage thresholds or technical adaptation requirements?',
        faq8Answer:
            'Provides end-to-end generation interfaces; users need no professional design background and can quickly generate images via natural language descriptions or sketch+text, supporting API access and platform integration.',

        // CTA Section
        ctaTitle: 'Start Using Dreamina 4.0 Now',
        ctaDescription:
            'Experience next-generation AI image generation technology and create stunning visual works',
        ctaButton: 'Try Dreamina on 微鲤AI',
        ctaDisclaimer: 'No credit card required, start creating now',
    },
}
